
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4hoOb", function(module, exports) {
/**
 * @generated SignedSource<<2be5a6d0d5481f5768efd2c04a31450b>>
 * @relayHash 2b75fc1121e53c1c0a5ad6a53dc0d745
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID da67c9639926a2efc46d2b199b1e767f62d394339ad04fad1158a6e32d14ceab
const $50da084713014cf6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "coverPictureWidth"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "coverPictureWidth",
                            "variableName": "coverPictureWidth"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "UpdateCoverPictureWidthPayload",
            "kind": "LinkedField",
            "name": "updateCoverPictureWidth",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EditorPageCoverPictureUpdateCoverPictureWidthMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EditorPageCoverPictureUpdateCoverPictureWidthMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "2b75fc1121e53c1c0a5ad6a53dc0d745",
            "id": "da67c9639926a2efc46d2b199b1e767f62d394339ad04fad1158a6e32d14ceab",
            "metadata": {},
            "name": "EditorPageCoverPictureUpdateCoverPictureWidthMutation",
            "operationKind": "mutation",
            "text": "mutation EditorPageCoverPictureUpdateCoverPictureWidthMutation($contentId:ID!,$coverPictureWidth:GraphQLCoverPictureWidth!){updateCoverPictureWidth(input:{contentId:$contentId,coverPictureWidth:$coverPictureWidth}){content{id}}}"
        }
    };
}();
$50da084713014cf6$var$node.hash = "d3df2b12316133bd2b6a3afaae602a82";
var $50da084713014cf6$export$2e2bcd8739ae039 = $50da084713014cf6$var$node;



var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1s5hv = parcelRequire("1s5hv");


var $inPa6 = parcelRequire("inPa6");


var $10CSJ = parcelRequire("10CSJ");


var $i9VoI = parcelRequire("i9VoI");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $e4o8D = parcelRequire("e4o8D");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $2vVvv = parcelRequire("2vVvv");


var $iP9x4 = parcelRequire("iP9x4");


var $4IoVL = parcelRequire("4IoVL");


var $gXrHX = parcelRequire("gXrHX");


var $7aRa9 = parcelRequire("7aRa9");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $1uFM6 = parcelRequire("1uFM6");


var $7PLO8 = parcelRequire("7PLO8");


var $3jwuS = parcelRequire("3jwuS");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $5kqgA = parcelRequire("5kqgA");


var $dA1Sn = parcelRequire("dA1Sn");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");


var $3WPGR = parcelRequire("3WPGR");


var $bKd7w = parcelRequire("bKd7w");


var $75Ax4 = parcelRequire("75Ax4");


var $lC6Qd = parcelRequire("lC6Qd");


var $frIzR = parcelRequire("frIzR");





var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $btHGY = parcelRequire("btHGY");
























const $2dd1934ae4bb18c2$var$COVER_IMAGE_FIXED_HEIGHT = 147;
const $2dd1934ae4bb18c2$var$COVER_IMAGE_WIDTH_TO_HEIGHT_RATIO = 38 / 7;
const $2dd1934ae4bb18c2$var$CALCULATE_SCALED_COVER_IMAGE_HEIGHT_FOR_EDIT_PAGE = `round(down, calc(100cqw / (${$2dd1934ae4bb18c2$var$COVER_IMAGE_WIDTH_TO_HEIGHT_RATIO})), 1px)`;
const $2dd1934ae4bb18c2$export$e9a5ef24ed345990 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "img" : t2;
        const { smartSpaceOverviewHeight: smartSpaceOverviewHeight, isFixedWidthImageOption: isFixedWidthImageOption, isRoundedCorners: isRoundedCorners, coverPicturePosition: coverPicturePosition, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ $42omo.createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_19y14qn": (0, $7sObp.default)(__cmplp.smartSpaceOverviewHeight, "px"),
                "--_7bw3ey": (0, $7sObp.default)(`center ${__cmplp.coverPicturePosition}%`)
            },
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_1bsb1osq _5ral1dfr _kqswstnw _rsuf19is _1h1t1u5u _16l4kb7n",
                __cmplp.smartSpaceOverviewHeight ? "_4t3ihojm" : __cmplp.isFixedWidthImageOption ? "_4t3i2pqz" : "_4t3i6w0c",
                __cmplp.isRoundedCorners ? "_2rkopb1k" : "_2rkon7od",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});


/* ImageWrapperCss.tsx generated by @compiled/babel-plugin v0.36.1 */ 





const $5368c62a8152c252$var$COVER_IMAGE_FIXED_HEIGHT = 147;
const $5368c62a8152c252$var$SMART_SPACE_OVERVIEW_FIXED_HEIGHT_FULL_WIDTH = 200;
const $5368c62a8152c252$var$COVER_IMAGE_WIDTH_TO_HEIGHT_RATIO = 38 / 7;
const $5368c62a8152c252$var$CALCULATE_SCALED_COVER_IMAGE_HEIGHT_FOR_EDIT_PAGE = `round(down, calc(100cqw / (${$5368c62a8152c252$var$COVER_IMAGE_WIDTH_TO_HEIGHT_RATIO})), 1px)`;
const $5368c62a8152c252$var$imageWrapperStyles = {
    base: "_1bsb1osq _5ral1dfr _kqswstnw _1h1t1u5u _16l4kb7n",
    fixed: "_4t3i2pqz",
    fixedHeight: "_4t3iuuw1",
    scaled: "_4t3i6w0c",
    roundedCorners: "_2rkopb1k"
};
const $5368c62a8152c252$export$b3be81165a87bf6f = ({ coverPicturePosition: coverPicturePosition, isFixedWidthImageOption: isFixedWidthImageOption, smartSpaceOverviewHeight: smartSpaceOverviewHeight, isRoundedCorners: isRoundedCorners, style: style, ...imgProps })=>{
    'use no memo'; // Exclude from React compiler - breaks unit tests when component uses compiled CSS
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        ...imgProps,
        alt: "",
        style: {
            objectPosition: `center ${coverPicturePosition}%`,
            ...style
        },
        className: (0, $gMc0m.default)([
            $5368c62a8152c252$var$imageWrapperStyles.base,
            $5368c62a8152c252$var$imageWrapperStyles[smartSpaceOverviewHeight ? 'fixedHeight' : isFixedWidthImageOption ? 'fixed' : 'scaled'],
            isRoundedCorners && $5368c62a8152c252$var$imageWrapperStyles.roundedCorners
        ])
    });
};


const $66db09fad5336912$export$75f07c36086c2c81 = (t0)=>{
    const $ = (0, $frIzR.c)(18);
    let coverPicturePosition;
    let imgProps;
    let isFixedWidthImageOption;
    let isRoundedCorners;
    let smartSpaceOverviewHeight;
    if ($[0] !== t0) {
        ({ coverPicturePosition: coverPicturePosition, isFixedWidthImageOption: isFixedWidthImageOption, smartSpaceOverviewHeight: smartSpaceOverviewHeight, isRoundedCorners: isRoundedCorners, ...imgProps } = t0);
        $[0] = t0;
        $[1] = coverPicturePosition;
        $[2] = imgProps;
        $[3] = isFixedWidthImageOption;
        $[4] = isRoundedCorners;
        $[5] = smartSpaceOverviewHeight;
    } else {
        coverPicturePosition = $[1];
        imgProps = $[2];
        isFixedWidthImageOption = $[3];
        isRoundedCorners = $[4];
        smartSpaceOverviewHeight = $[5];
    }
    if ((0, $6mKj3.expValEquals)("confluence_page_cover_picture_css_migration", "isEnabled", true)) {
        let t1;
        if ($[6] !== coverPicturePosition || $[7] !== imgProps || $[8] !== isFixedWidthImageOption || $[9] !== isRoundedCorners || $[10] !== smartSpaceOverviewHeight) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5368c62a8152c252$export$b3be81165a87bf6f), {
                ...imgProps,
                coverPicturePosition: coverPicturePosition,
                isFixedWidthImageOption: isFixedWidthImageOption,
                smartSpaceOverviewHeight: smartSpaceOverviewHeight,
                isRoundedCorners: isRoundedCorners
            });
            $[6] = coverPicturePosition;
            $[7] = imgProps;
            $[8] = isFixedWidthImageOption;
            $[9] = isRoundedCorners;
            $[10] = smartSpaceOverviewHeight;
            $[11] = t1;
        } else t1 = $[11];
        return t1;
    }
    let t1;
    if ($[12] !== coverPicturePosition || $[13] !== imgProps || $[14] !== isFixedWidthImageOption || $[15] !== isRoundedCorners || $[16] !== smartSpaceOverviewHeight) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2dd1934ae4bb18c2$export$e9a5ef24ed345990), {
            ...imgProps,
            alt: "",
            coverPicturePosition: coverPicturePosition,
            isFixedWidthImageOption: isFixedWidthImageOption,
            smartSpaceOverviewHeight: smartSpaceOverviewHeight,
            isRoundedCorners: isRoundedCorners
        });
        $[12] = coverPicturePosition;
        $[13] = imgProps;
        $[14] = isFixedWidthImageOption;
        $[15] = isRoundedCorners;
        $[16] = smartSpaceOverviewHeight;
        $[17] = t1;
    } else t1 = $[17];
    return t1;
};


const $6daaa50e0e3ea99a$var$styles = {
    loading: "_kqswh2mm _4t3i1osq _bfhkysee"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6daaa50e0e3ea99a$var$LoadingDivWithCss = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(11);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { smartSpaceOverviewHeight: smartSpaceOverviewHeight, dynamicCoverImageHeight: dynamicCoverImageHeight, ...__cmpldp } = __cmplp;
        const t3 = `${__cmplp.smartSpaceOverviewHeight ?? __cmplp.dynamicCoverImageHeight}px`;
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $7sObp.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        const t5 = `-${__cmplp.smartSpaceOverviewHeight ?? __cmplp.dynamicCoverImageHeight}px`;
        let t6;
        if ($[5] !== t5) {
            t6 = (0, $7sObp.default)(t5);
            $[5] = t5;
            $[6] = t6;
        } else t6 = $[6];
        let t7;
        if ($[7] !== __cmpls || $[8] !== t4 || $[9] !== t6) {
            t7 = {
                ...__cmpls,
                "--_13y1ha6": t4,
                "--_1jwbla4": t6
            };
            $[7] = __cmpls;
            $[8] = t4;
            $[9] = t6;
            $[10] = t7;
        } else t7 = $[10];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: t7,
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_11q7ysee _2rkon7od _kqswh2mm _4t3i1osq _1tke144s _otyr1d07",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $6daaa50e0e3ea99a$var$LoadingDiv = (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { dynamicCoverImageHeight: dynamicCoverImageHeight, smartSpaceOverviewHeight: smartSpaceOverviewHeight } = t0;
    if ((0, $6mKj3.expValEquals)("confluence_page_cover_picture_css_migration", "isEnabled", true)) {
        const t1 = smartSpaceOverviewHeight ? `${smartSpaceOverviewHeight}px` : dynamicCoverImageHeight ? `${dynamicCoverImageHeight}px` : undefined;
        const t2 = smartSpaceOverviewHeight ? `-${smartSpaceOverviewHeight}px` : dynamicCoverImageHeight ? `-${dynamicCoverImageHeight}px` : undefined;
        let t3;
        if ($[0] !== t1 || $[1] !== t2) {
            t3 = {
                minHeight: t1,
                marginBottom: t2
            };
            $[0] = t1;
            $[1] = t2;
            $[2] = t3;
        } else t3 = $[2];
        let t4;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
            t4 = (0, $gMc0m.default)([
                $6daaa50e0e3ea99a$var$styles.loading
            ]);
            $[3] = t4;
        } else t4 = $[3];
        let t5;
        if ($[4] !== t3) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                style: t3,
                "data-testid": "cover-pic-loading-css",
                className: t4
            });
            $[4] = t3;
            $[5] = t5;
        } else t5 = $[5];
        return t5;
    }
    let t1;
    if ($[6] !== dynamicCoverImageHeight || $[7] !== smartSpaceOverviewHeight) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6daaa50e0e3ea99a$var$LoadingDivWithCss, {
            "data-testid": "cover-pic-loading",
            dynamicCoverImageHeight: dynamicCoverImageHeight,
            smartSpaceOverviewHeight: smartSpaceOverviewHeight
        });
        $[6] = dynamicCoverImageHeight;
        $[7] = smartSpaceOverviewHeight;
        $[8] = t1;
    } else t1 = $[8];
    return t1;
};
const $6daaa50e0e3ea99a$export$22e679d20747684f = (t0)=>{
    const $ = (0, $frIzR.c)(22);
    const { coverPicture: coverPicture, dynamicCoverImageHeight: dynamicCoverImageHeight, showErrorFlag: showErrorFlag, mediaConfig: mediaConfig, ssrConfig: ssrConfig, contentId: contentId, hasSSRConfigInSSRModeOrHydration: hasSSRConfigInSSRModeOrHydration, isFixedWidthImageOption: isFixedWidthImageOption, smartSpaceOverviewHeight: smartSpaceOverviewHeight, isAIGenerated: isAIGenerated, isRoundedCorners: isRoundedCorners } = t0;
    const useSSRConfig = hasSSRConfigInSSRModeOrHydration && !isAIGenerated;
    let t1;
    if ($[0] !== mediaConfig || $[1] !== ssrConfig || $[2] !== useSSRConfig) {
        t1 = useSSRConfig ? ssrConfig && ssrConfig.config : mediaConfig && {
            authProvider: mediaConfig.authProvider
        };
        $[0] = mediaConfig;
        $[1] = ssrConfig;
        $[2] = useSSRConfig;
        $[3] = t1;
    } else t1 = $[3];
    const mediaClientConfig = t1;
    if (mediaClientConfig) {
        const t2 = String(coverPicture.current.draft?.value.id);
        const t3 = useSSRConfig ? `contentId-${contentId}` : mediaConfig?.collection;
        let t4;
        if ($[4] !== t2 || $[5] !== t3) {
            t4 = {
                mediaItemType: "file",
                id: t2,
                collectionName: t3
            };
            $[4] = t2;
            $[5] = t3;
            $[6] = t4;
        } else t4 = $[6];
        const t5 = String(coverPicture.current.draft?.value.id);
        let t6;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
            t6 = {
                allowAnimated: true,
                mode: "full-fit",
                upscale: false
            };
            $[7] = t6;
        } else t6 = $[7];
        const t7 = useSSRConfig ? ssrConfig?.mode : undefined;
        let t8;
        if ($[8] !== coverPicture.current.draft?.value || $[9] !== dynamicCoverImageHeight || $[10] !== isAIGenerated || $[11] !== isFixedWidthImageOption || $[12] !== isRoundedCorners || $[13] !== showErrorFlag || $[14] !== smartSpaceOverviewHeight) {
            t8 = (t9)=>{
                const { data: data, loading: loading, error: error } = t9;
                if (loading) {
                    if (isAIGenerated && ((0, $6mKj3.isExperimentEnabled)("cc_page_experiences_ai_header_image_generation") || (0, $6mKj3.isExperimentEnabled)("cc_page_experiences_aifc_auto_generated_header_img"))) return null;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6daaa50e0e3ea99a$var$LoadingDiv, {
                        dynamicCoverImageHeight: dynamicCoverImageHeight,
                        smartSpaceOverviewHeight: smartSpaceOverviewHeight
                    });
                }
                if (!data) return null;
                if (error) showErrorFlag();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $66db09fad5336912$export$75f07c36086c2c81), {
                    "data-testid": "actual-cover-picture",
                    id: "actual-cover-picture",
                    src: data.src,
                    coverPicturePosition: coverPicture.current.draft?.value.position,
                    isFixedWidthImageOption: isFixedWidthImageOption,
                    smartSpaceOverviewHeight: smartSpaceOverviewHeight,
                    isRoundedCorners: isRoundedCorners,
                    className: "cover-picture-wrapper-dangerously-set-inner-html"
                });
            };
            $[8] = coverPicture.current.draft?.value;
            $[9] = dynamicCoverImageHeight;
            $[10] = isAIGenerated;
            $[11] = isFixedWidthImageOption;
            $[12] = isRoundedCorners;
            $[13] = showErrorFlag;
            $[14] = smartSpaceOverviewHeight;
            $[15] = t8;
        } else t8 = $[15];
        let t9;
        if ($[16] !== mediaClientConfig || $[17] !== t4 || $[18] !== t5 || $[19] !== t7 || $[20] !== t8) {
            t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $btHGY.MediaImageWithErrorBoundary), {
                identifier: t4,
                mediaClientConfig: mediaClientConfig,
                key: t5,
                apiConfig: t6,
                ssr: t7
            }, t8);
            $[16] = mediaClientConfig;
            $[17] = t4;
            $[18] = t5;
            $[19] = t7;
            $[20] = t8;
            $[21] = t9;
        } else t9 = $[21];
        return t9;
    }
};














var $9hlns = parcelRequire("9hlns");














var $2Maq7 = parcelRequire("2Maq7");











var $eEA8O = parcelRequire("eEA8O");


var $fZtQj = parcelRequire("fZtQj");


var $lGgRw = parcelRequire("lGgRw");




















var $3gadb = parcelRequire("3gadb");


var $gKvd9 = parcelRequire("gKvd9");


var $1kVeP = parcelRequire("1kVeP");


var $3HOqx = parcelRequire("3HOqx");


var $1GzhS = parcelRequire("1GzhS");

var $ecnYn = parcelRequire("ecnYn");


var $hY5v2 = parcelRequire("hY5v2");


var $gmg8x = parcelRequire("gmg8x");


var $jOIil = parcelRequire("jOIil");








var $ep3mz = parcelRequire("ep3mz");


var $cEgMD = parcelRequire("cEgMD");





var $5spQU = parcelRequire("5spQU");











var $ghftu = parcelRequire("ghftu");


var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");


var $g5lKx = parcelRequire("g5lKx");











var $jVylI = parcelRequire("jVylI");

const $98591a14e75c6a83$var$i18n = (0, $aXWIB.defineMessages)({
    fixedWidthSelectOption: {
        id: "content-topper.page-title.popup.fixed-width.option",
        defaultMessage: "Fixed width"
    },
    fullWidthSelectOption: {
        id: "content-topper.page-title.popup.full-width.option",
        defaultMessage: "Full width"
    },
    selectWidthLabel: {
        id: "content-topper.page-title.popup.select-width.label",
        defaultMessage: "Select width: {selectedWidth}"
    }
});
const $98591a14e75c6a83$export$6164b97a36f48473 = (t0)=>{
    const $ = (0, $frIzR.c)(29);
    const { userOffline: userOffline, onImageWidthChange: onImageWidthChange, selectedWidth: t1, onCoverImageWidthDropdownOptionSelected: onCoverImageWidthDropdownOptionSelected } = t0;
    const selectedWidth = t1 === undefined ? (0, $jVylI.COVERPICTUREWIDTH).FULL : t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const intl = (0, $aXWIB.useIntl)();
    let t2;
    if ($[0] !== createAnalyticsEvent) {
        t2 = (coverPictureWidth)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    source: "widthToggleDropdownButton",
                    actionSubject: "button",
                    actionSubjectId: `${coverPictureWidth}WidthToggleDropdownButton`
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = t2;
    } else t2 = $[1];
    const createWidthToggleDropdownAnalytics = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $g5lKx.layers).dialog();
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== intl || $[4] !== selectedWidth || $[5] !== userOffline) {
        t4 = (t5)=>{
            const { triggerRef: triggerRef, ...props } = t5;
            const selectedLabel = selectedWidth === (0, $jVylI.COVERPICTUREWIDTH).FULL ? intl.formatMessage($98591a14e75c6a83$var$i18n.fullWidthSelectOption) : intl.formatMessage($98591a14e75c6a83$var$i18n.fixedWidthSelectOption);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                ...props,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                    label: "",
                    size: "small"
                }),
                ref: triggerRef,
                shouldFitContainer: true,
                style: {
                    textAlign: "left"
                },
                isDisabled: userOffline,
                "aria-label": (0, $9wGTI.fg)("a11y-fix-full-width-dropdown-label") ? intl.formatMessage($98591a14e75c6a83$var$i18n.selectWidthLabel, {
                    selectedWidth: selectedLabel
                }) : undefined
            }, selectedWidth === (0, $jVylI.COVERPICTUREWIDTH).FULL ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $98591a14e75c6a83$var$i18n.fullWidthSelectOption) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $98591a14e75c6a83$var$i18n.fixedWidthSelectOption));
        };
        $[3] = intl;
        $[4] = selectedWidth;
        $[5] = userOffline;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== createWidthToggleDropdownAnalytics || $[8] !== onCoverImageWidthDropdownOptionSelected || $[9] !== onImageWidthChange || $[10] !== selectedWidth) {
        t5 = ()=>{
            onImageWidthChange((0, $jVylI.COVERPICTUREWIDTH).FULL);
            createWidthToggleDropdownAnalytics((0, $jVylI.COVERPICTUREWIDTH).FULL);
            onCoverImageWidthDropdownOptionSelected?.(selectedWidth !== (0, $jVylI.COVERPICTUREWIDTH).FULL);
        };
        $[7] = createWidthToggleDropdownAnalytics;
        $[8] = onCoverImageWidthDropdownOptionSelected;
        $[9] = onImageWidthChange;
        $[10] = selectedWidth;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $98591a14e75c6a83$var$i18n.fullWidthSelectOption);
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== t5) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            key: (0, $jVylI.COVERPICTUREWIDTH).FULL,
            onClick: t5,
            testId: "coverPictureFullWidthToggleDropdownItem"
        }, t6);
        $[13] = t5;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== createWidthToggleDropdownAnalytics || $[16] !== onCoverImageWidthDropdownOptionSelected || $[17] !== onImageWidthChange || $[18] !== selectedWidth) {
        t8 = ()=>{
            onImageWidthChange((0, $jVylI.COVERPICTUREWIDTH).FIXED);
            createWidthToggleDropdownAnalytics((0, $jVylI.COVERPICTUREWIDTH).FIXED);
            onCoverImageWidthDropdownOptionSelected?.(selectedWidth !== (0, $jVylI.COVERPICTUREWIDTH).FIXED);
        };
        $[15] = createWidthToggleDropdownAnalytics;
        $[16] = onCoverImageWidthDropdownOptionSelected;
        $[17] = onImageWidthChange;
        $[18] = selectedWidth;
        $[19] = t8;
    } else t8 = $[19];
    let t9;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $98591a14e75c6a83$var$i18n.fixedWidthSelectOption);
        $[20] = t9;
    } else t9 = $[20];
    let t10;
    if ($[21] !== t8) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            key: (0, $jVylI.COVERPICTUREWIDTH).FIXED,
            onClick: t8,
            testId: "coverPictureFixedWidthToggleDropdownItem"
        }, t9);
        $[21] = t8;
        $[22] = t10;
    } else t10 = $[22];
    let t11;
    if ($[23] !== t10 || $[24] !== t7) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), null, t7, t10);
        $[23] = t10;
        $[24] = t7;
        $[25] = t11;
    } else t11 = $[25];
    let t12;
    if ($[26] !== t11 || $[27] !== t4) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
            placement: "bottom-start",
            zIndex: t3,
            shouldRenderToParent: true,
            shouldFitContainer: true,
            trigger: t4
        }, t11);
        $[26] = t11;
        $[27] = t4;
        $[28] = t12;
    } else t12 = $[28];
    return t12;
};



var $f7B1p = parcelRequire("f7B1p");







const $d69b5edb6613d5ce$export$d3c50eeab3c808b = async (downloadLink)=>{
    return (0, $f7B1p.cfetch)(`/wiki/rest/internals/1.0/unsplash/download`, {
        method: 'POST',
        body: JSON.stringify({
            downloadLink: downloadLink
        }),
        headers: {
            'Content-Type': 'application/json'
        }
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
        });
        throw error;
    });
};


const $15d7949f30979aaa$export$8d7ce798f348099f = ()=>[
        'Based on this page information, output a single sentence (max 20 words) describing an image suitable as a cover image.',
        'The image must visually represent the main topic of the page using relevant symbols, objects, or metaphors.',
        'Do not include human elements unless distant and unrecognizable.',
        'Include a specific visual style and color tone.',
        'Output only the sentence. No preamble. No quotes. No markdown.'
    ].join(' ');
const $15d7949f30979aaa$export$91104a6680d86a2c = (raw)=>{
    const trimmed = (raw ?? '').trim();
    const unquoted = trimmed.startsWith('"') && trimmed.endsWith('"') || trimmed.startsWith("'") && trimmed.endsWith("'") ? trimmed.slice(1, -1).trim() : trimmed;
    const firstLine = unquoted.split(/\r?\n/)[0]?.trim() ?? '';
    const withoutPrefix = firstLine.replace(/^(prompt|output)\s*:\s*/i, '').trim();
    const words = withoutPrefix.split(/\s+/).filter(Boolean);
    return words.length <= 25 ? withoutPrefix : words.slice(0, 25).join(' ');
};
const $15d7949f30979aaa$export$bf7a2998b22ba28c = ()=>{
    // Mirror the EditorTitle pattern: pick the first non-chromeless editor.
    const proseMirrors = Array.from(document.querySelectorAll('.ProseMirror')).filter((el)=>!el.closest('[data-testid="chromeless-editor"]') && !el.closest('[data-editor-popup]'));
    return proseMirrors[0]?.dataset?.editorId;
};


const $e611c24abe969f89$var$i18n = (0, $aXWIB.defineMessages)({
    popupTitleLabel: {
        id: "content-topper.page-title.popup.label",
        defaultMessage: "Header image"
    },
    popupTitleLabelSubtext: {
        id: "content-topper.page-title.popup.label.subtext",
        defaultMessage: "We recommend images 1100px or wider."
    },
    repositionButton: {
        id: "content-topper.page-title.popup.reposition",
        defaultMessage: "Reposition"
    },
    removeHeaderButton: {
        id: "content-topper.page-title.popup.remove-image",
        defaultMessage: "Remove image"
    },
    suggestPromptLabel: {
        id: "content-topper.page-title.popup.suggest-image-prompt",
        defaultMessage: "Suggest"
    },
    suggestPromptTooltip: {
        id: "content-topper.page-title.popup.suggest-image-prompt.tooltip",
        defaultMessage: "Suggest from page content"
    }
});
const $e611c24abe969f89$var$PopupWrapperStyles = (0, $ecnYn.xcss)({
    padding: 'space.200',
    width: '280px',
    userSelect: 'none'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e611c24abe969f89$var$DeleteButtonWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1gqwidpf _q93c5u61 _1v09u2gc _p55o5u61",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e611c24abe969f89$var$PositionIconWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_19pkyh40 _2hwxidpf _otyridpf _18u0j39m _t9ec2i46",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e611c24abe969f89$var$MenuOptionsWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_y3gn1e5h",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e611c24abe969f89$export$5e27412e512156d4 = (t0)=>{
    const $ = (0, $frIzR.c)(60);
    const { imageSrc: imageSrc, imageAltText: imageAltText, initialUnsplashInfoArray: initialUnsplashInfoArray, openMediaBrowser: openMediaBrowser, coverPictureState: coverPictureState, closePopup: closePopup, setIsUploadingPicture: setIsUploadingPicture, handleUnsplashUpload: handleUnsplashUpload, onReposition: onReposition, onDelete: onDelete, dropdownRef: dropdownRef, dropdownPopupComponentRef: dropdownPopupComponentRef, userOffline: userOffline, contentId: contentId, isPageTitleComponent: isPageTitleComponent, onImageWidthChange: onImageWidthChange, onCoverImageWidthDropdownOptionSelected: onCoverImageWidthDropdownOptionSelected, generateAIHeaderImage: generateAIHeaderImage } = t0;
    const intl = (0, $aXWIB.useIntl)();
    const [t1] = (0, $ep3mz.usePageState)();
    const { spaceKey: spaceKey } = t1;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isSuggestingPrompt, setIsSuggestingPrompt] = (0, $42omo.useState)(false);
    const [suggestedPrompt, setSuggestedPrompt] = (0, $42omo.useState)("");
    const mountedRef = (0, $42omo.useRef)(true);
    let t2;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            mountedRef.current = true;
            return ()=>{
                mountedRef.current = false;
            };
        };
        t3 = [];
        $[0] = t2;
        $[1] = t3;
    } else {
        t2 = $[0];
        t3 = $[1];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[2] !== createAnalyticsEvent) {
        t4 = (t5)=>{
            const { isButtonDisabled: isButtonDisabled, isEditorIdMissing: isEditorIdMissing } = t5;
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    source: "unsplashPopupMenu",
                    actionSubject: "button",
                    actionSubjectId: "headerImagePromptSuggestion",
                    attributes: {
                        isButtonDisabled: isButtonDisabled,
                        isEditorIdMissing: isEditorIdMissing
                    }
                }
            }).fire();
        };
        $[2] = createAnalyticsEvent;
        $[3] = t4;
    } else t4 = $[3];
    const fireSuggestHeaderImageButtonAnalytics = t4;
    let t5;
    if ($[4] !== createAnalyticsEvent) {
        t5 = (t6)=>{
            const { promptGenerationSuccessful: promptGenerationSuccessful, resultType: resultType, isRegeneratingPrompt: isRegeneratingPrompt } = t6;
            createAnalyticsEvent({
                type: "sendOperationalEvent",
                data: {
                    actionSubject: "headerImagePromptSuggestionGeneration",
                    action: promptGenerationSuccessful && resultType === "complete" ? "completed" : "failed",
                    source: "headerImagePromptSuggestionButton",
                    attributes: {
                        promptGenerationSuccessful: promptGenerationSuccessful,
                        resultType: resultType,
                        isRegeneratingPrompt: isRegeneratingPrompt
                    }
                }
            }).fire();
        };
        $[4] = createAnalyticsEvent;
        $[5] = t5;
    } else t5 = $[5];
    const fireSuggestHeaderImagePromptResultAnalytics = t5;
    let t6;
    if ($[6] !== fireSuggestHeaderImageButtonAnalytics || $[7] !== fireSuggestHeaderImagePromptResultAnalytics || $[8] !== isSuggestingPrompt || $[9] !== suggestedPrompt || $[10] !== userOffline) {
        t6 = ()=>{
            const isButtonDisabled_0 = userOffline || isSuggestingPrompt;
            const targetEditorId = (0, $15d7949f30979aaa$export$bf7a2998b22ba28c)();
            fireSuggestHeaderImageButtonAnalytics({
                isButtonDisabled: isButtonDisabled_0,
                isEditorIdMissing: !targetEditorId
            });
            if (isButtonDisabled_0 || !targetEditorId) return;
            const isRegenerating = Boolean(suggestedPrompt?.trim());
            setIsSuggestingPrompt(true);
            setSuggestedPrompt("");
            (0, $jOIil.eventHub).publishToEditor({
                event: "start prompt",
                data: {
                    targetEditorId: targetEditorId,
                    analyticSourceId: "confluenceCoverImagePromptSuggestionPopup",
                    prompt: "custom prompt",
                    promptText: (0, $15d7949f30979aaa$export$8d7ce798f348099f)(),
                    adjustSelection: "fullDocument",
                    hideModal: true,
                    streamingCallback: (data)=>{
                        if (data.type === "complete") {
                            const suggestion = (0, $15d7949f30979aaa$export$91104a6680d86a2c)(data.result ?? "");
                            if (mountedRef.current) {
                                setIsSuggestingPrompt(false);
                                setSuggestedPrompt(suggestion);
                                fireSuggestHeaderImagePromptResultAnalytics({
                                    promptGenerationSuccessful: true,
                                    resultType: data.type,
                                    isRegeneratingPrompt: isRegenerating
                                });
                            } else fireSuggestHeaderImagePromptResultAnalytics({
                                promptGenerationSuccessful: false,
                                resultType: "not mounted",
                                isRegeneratingPrompt: isRegenerating
                            });
                        } else if (data.type === "error" || data.type === "response too similar") {
                            if (mountedRef.current) setIsSuggestingPrompt(false);
                            fireSuggestHeaderImagePromptResultAnalytics({
                                promptGenerationSuccessful: false,
                                resultType: data.type,
                                isRegeneratingPrompt: isRegenerating
                            });
                        }
                    }
                }
            });
        };
        $[6] = fireSuggestHeaderImageButtonAnalytics;
        $[7] = fireSuggestHeaderImagePromptResultAnalytics;
        $[8] = isSuggestingPrompt;
        $[9] = suggestedPrompt;
        $[10] = userOffline;
        $[11] = t6;
    } else t6 = $[11];
    const handleSuggestImagePromptClick = t6;
    let t7;
    if ($[12] !== closePopup || $[13] !== coverPictureState || $[14] !== experienceTracker || $[15] !== handleUnsplashUpload || $[16] !== setIsUploadingPicture) {
        t7 = async (url, downloadLink)=>{
            experienceTracker.start({
                name: (0, $irVI7.COVER_PICTURE_UNSPLASH_UPLOAD_EXPERIENCE)
            });
            await (0, $d69b5edb6613d5ce$export$d3c50eeab3c808b)(downloadLink);
            handleUnsplashUpload(url);
            setIsUploadingPicture(true);
            coverPictureState.setIsUploadingPicture(true);
            closePopup();
        };
        $[12] = closePopup;
        $[13] = coverPictureState;
        $[14] = experienceTracker;
        $[15] = handleUnsplashUpload;
        $[16] = setIsUploadingPicture;
        $[17] = t7;
    } else t7 = $[17];
    const onUnsplashImageClick = t7;
    let t8;
    if ($[18] !== coverPictureState || $[19] !== onUnsplashImageClick) {
        t8 = async (t9)=>{
            const { fullSizeImageUrl: fullSizeImageUrl, downloadLink: downloadLink_0 } = t9;
            await onUnsplashImageClick(fullSizeImageUrl, downloadLink_0);
            coverPictureState.setIsChangingPicture(false);
        };
        $[18] = coverPictureState;
        $[19] = onUnsplashImageClick;
        $[20] = t8;
    } else t8 = $[20];
    const handleImageSelection = t8;
    const t9 = dropdownRef;
    let t10;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e611c24abe969f89$var$i18n.popupTitleLabelSubtext);
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e611c24abe969f89$var$i18n.popupTitleLabel);
        $[22] = t11;
    } else t11 = $[22];
    const t12 = dropdownPopupComponentRef;
    let t13;
    if ($[23] !== contentId || $[24] !== handleImageSelection || $[25] !== imageAltText || $[26] !== imageSrc || $[27] !== initialUnsplashInfoArray || $[28] !== isPageTitleComponent || $[29] !== openMediaBrowser || $[30] !== t12 || $[31] !== userOffline) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hY5v2.UnsplashSearch), {
            selectedImageUrl: imageSrc,
            imageAltText: imageAltText,
            initialUnsplashResults: initialUnsplashInfoArray,
            idPrefix: "unsplash-popup",
            helperMessage: t10,
            handleImageSelection: handleImageSelection,
            openMediaBrowser: openMediaBrowser,
            sectionLabel: t11,
            dropdownPopupComponentRef: t12,
            isDisabled: userOffline,
            contentId: contentId,
            isPageTitleComponent: isPageTitleComponent,
            isNoImageAllowed: false,
            analyticsSource: "editorPageCoverPicture",
            analyticsActionSubject: "headerImageUpload",
            analyticsActionSubjectId: "headerImageUploadButtonClicked",
            enableBottomSpacing: false
        });
        $[23] = contentId;
        $[24] = handleImageSelection;
        $[25] = imageAltText;
        $[26] = imageSrc;
        $[27] = initialUnsplashInfoArray;
        $[28] = isPageTitleComponent;
        $[29] = openMediaBrowser;
        $[30] = t12;
        $[31] = userOffline;
        $[32] = t13;
    } else t13 = $[32];
    let t14;
    if ($[33] !== coverPictureState.state || $[34] !== onCoverImageWidthDropdownOptionSelected || $[35] !== onImageWidthChange || $[36] !== spaceKey || $[37] !== userOffline) {
        t14 = !(0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) && typeof onImageWidthChange === "function" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $98591a14e75c6a83$export$6164b97a36f48473), {
            onImageWidthChange: onImageWidthChange,
            userOffline: userOffline,
            selectedWidth: coverPictureState.state.coverPictureWidth,
            onCoverImageWidthDropdownOptionSelected: onCoverImageWidthDropdownOptionSelected
        }) : null;
        $[33] = coverPictureState.state;
        $[34] = onCoverImageWidthDropdownOptionSelected;
        $[35] = onImageWidthChange;
        $[36] = spaceKey;
        $[37] = userOffline;
        $[38] = t14;
    } else t14 = $[38];
    let t15;
    if ($[39] !== onReposition || $[40] !== userOffline) {
        t15 = typeof onReposition === "function" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e611c24abe969f89$var$PositionIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1kVeP))), {
                label: "",
                spacing: "none"
            })),
            testId: "reposition-image-button",
            isDisabled: userOffline,
            onClick: onReposition,
            shouldFitContainer: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e611c24abe969f89$var$MenuOptionsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e611c24abe969f89$var$i18n.repositionButton))) : null;
        $[39] = onReposition;
        $[40] = userOffline;
        $[41] = t15;
    } else t15 = $[41];
    let t16;
    if ($[42] !== createAnalyticsEvent || $[43] !== generateAIHeaderImage || $[44] !== handleSuggestImagePromptClick || $[45] !== intl || $[46] !== isSuggestingPrompt || $[47] !== suggestedPrompt || $[48] !== userOffline) {
        t16 = (0, $6mKj3.isExperimentEnabled)("cc_page_experiences_ai_header_image_generation") && (0, $5spQU.isFeatureEnabled)("confluence", "confluence-ai") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gmg8x.RovoHeaderImageGenerator), {
            generateAIHeaderImage: generateAIHeaderImage,
            prefillText: suggestedPrompt || undefined,
            onSubmit: (t17)=>{
                const { selectedTheme: selectedTheme } = t17;
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "clicked",
                        actionSubject: "button",
                        actionSubjectId: "headerImageGenerationSubmitted",
                        source: "editorPageCoverPicture",
                        attributes: {
                            selectedTheme: selectedTheme
                        }
                    }
                }).fire();
            },
            moreActionsButton: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                content: intl.formatMessage($e611c24abe969f89$var$i18n.suggestPromptTooltip),
                position: "bottom"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                type: "button",
                appearance: "subtle",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3HOqx))), {
                    label: ""
                }),
                isDisabled: Boolean(userOffline) || isSuggestingPrompt,
                onClick: handleSuggestImagePromptClick,
                testId: "suggest-ai-image-prompt-button"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e611c24abe969f89$var$i18n.suggestPromptLabel)))
        });
        $[42] = createAnalyticsEvent;
        $[43] = generateAIHeaderImage;
        $[44] = handleSuggestImagePromptClick;
        $[45] = intl;
        $[46] = isSuggestingPrompt;
        $[47] = suggestedPrompt;
        $[48] = userOffline;
        $[49] = t16;
    } else t16 = $[49];
    let t17;
    if ($[50] !== onDelete || $[51] !== userOffline) {
        t17 = typeof onDelete === "function" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e611c24abe969f89$var$DeleteButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))), {
                label: ""
            }),
            shouldFitContainer: true,
            onClick: onDelete,
            isDisabled: userOffline,
            testId: "remove-image-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e611c24abe969f89$var$MenuOptionsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e611c24abe969f89$var$i18n.removeHeaderButton)))) : null;
        $[50] = onDelete;
        $[51] = userOffline;
        $[52] = t17;
    } else t17 = $[52];
    let t18;
    if ($[53] !== t13 || $[54] !== t14 || $[55] !== t15 || $[56] !== t16 || $[57] !== t17 || $[58] !== t9) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            ref: t9,
            xcss: $e611c24abe969f89$var$PopupWrapperStyles,
            space: "space.100"
        }, t13, t14, t15, t16, t17);
        $[53] = t13;
        $[54] = t14;
        $[55] = t15;
        $[56] = t16;
        $[57] = t17;
        $[58] = t9;
        $[59] = t18;
    } else t18 = $[59];
    return t18;
};


const $a391e9da6cc7b48e$var$i18n = (0, $aXWIB.defineMessages)({
    headerLabel: {
        id: "content-topper.add.header.image.message.floating-toolbar",
        defaultMessage: "Header image"
    },
    updateImage: {
        id: "content-topper.page-title.popup.update.header.image",
        defaultMessage: "Update header image"
    }
});
const $a391e9da6cc7b48e$export$44d946b74397afda = (t0)=>{
    const $ = (0, $frIzR.c)(25);
    const { isModalOpenState: isModalOpenState, closePopup: closePopup, initialUnsplashInfoArray: initialUnsplashInfoArray, openMediaBrowser: openMediaBrowser, userOffline: userOffline, handleUnsplashUpload: handleUnsplashUpload, setIsUploadingPicture: setIsUploadingPicture, coverPictureState: coverPictureState, floatingToolbarButtonStyle: floatingToolbarButtonStyle, onAddHeaderImageButtonClicked: onAddHeaderImageButtonClicked, onAddHeaderImageButtonHovered: onAddHeaderImageButtonHovered, onReposition: onReposition, onDelete: onDelete, imageSrc: imageSrc, dropdownRef: dropdownRef, dropdownPopupComponentRef: dropdownPopupComponentRef, contentId: contentId, generateAIHeaderImage: generateAIHeaderImage } = t0;
    let t1;
    if ($[0] !== closePopup || $[1] !== contentId || $[2] !== coverPictureState || $[3] !== dropdownPopupComponentRef || $[4] !== dropdownRef || $[5] !== generateAIHeaderImage || $[6] !== handleUnsplashUpload || $[7] !== imageSrc || $[8] !== initialUnsplashInfoArray || $[9] !== onDelete || $[10] !== onReposition || $[11] !== openMediaBrowser || $[12] !== setIsUploadingPicture) {
        t1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e611c24abe969f89$export$5e27412e512156d4), {
                dropdownRef: dropdownRef,
                imageSrc: imageSrc,
                initialUnsplashInfoArray: initialUnsplashInfoArray,
                openMediaBrowser: openMediaBrowser,
                handleUnsplashUpload: handleUnsplashUpload,
                setIsUploadingPicture: setIsUploadingPicture,
                coverPictureState: coverPictureState,
                closePopup: closePopup,
                onReposition: onReposition,
                onDelete: onDelete,
                dropdownPopupComponentRef: dropdownPopupComponentRef,
                contentId: contentId,
                isPageTitleComponent: true,
                generateAIHeaderImage: generateAIHeaderImage
            });
        $[0] = closePopup;
        $[1] = contentId;
        $[2] = coverPictureState;
        $[3] = dropdownPopupComponentRef;
        $[4] = dropdownRef;
        $[5] = generateAIHeaderImage;
        $[6] = handleUnsplashUpload;
        $[7] = imageSrc;
        $[8] = initialUnsplashInfoArray;
        $[9] = onDelete;
        $[10] = onReposition;
        $[11] = openMediaBrowser;
        $[12] = setIsUploadingPicture;
        $[13] = t1;
    } else t1 = $[13];
    let t2;
    if ($[14] !== floatingToolbarButtonStyle || $[15] !== isModalOpenState || $[16] !== onAddHeaderImageButtonClicked || $[17] !== onAddHeaderImageButtonHovered || $[18] !== userOffline) {
        t2 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                ...triggerProps,
                isSelected: isModalOpenState,
                appearance: "subtle",
                style: floatingToolbarButtonStyle || {},
                testId: "add-header-image-button",
                spacing: "compact",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fZtQj))), {
                    label: ""
                }),
                onClick: onAddHeaderImageButtonClicked,
                isDisabled: userOffline,
                onMouseEnter: onAddHeaderImageButtonHovered
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                className: "add-header-image-button"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $a391e9da6cc7b48e$var$i18n.headerLabel)));
        $[14] = floatingToolbarButtonStyle;
        $[15] = isModalOpenState;
        $[16] = onAddHeaderImageButtonClicked;
        $[17] = onAddHeaderImageButtonHovered;
        $[18] = userOffline;
        $[19] = t2;
    } else t2 = $[19];
    let t3;
    if ($[20] !== closePopup || $[21] !== isModalOpenState || $[22] !== t1 || $[23] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
            isOpen: isModalOpenState,
            onClose: closePopup,
            placement: "bottom-start",
            role: "dialog",
            shouldRenderToParent: false,
            content: t1,
            trigger: t2
        });
        $[20] = closePopup;
        $[21] = isModalOpenState;
        $[22] = t1;
        $[23] = t2;
        $[24] = t3;
    } else t3 = $[24];
    return t3;
};








async function $3297a981dc10fa5b$export$c23d8af8b1b8f2d7(queryWord, pageNumber, isPageTitleComponent) {
    return (0, $f7B1p.cfetch)(`/wiki/rest/internals/1.0/unsplash/search?query=${queryWord}&pageNumber=${pageNumber}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((response)=>response.json()).then((responseData)=>{
        const unsplashResults = responseData.results ?? [];
        return unsplashResults.map((result)=>({
                artistName: result.user.name,
                artistUrl: result.user.links.html + (0, $75Ax4.REFERRAL_LINK),
                fullSizeImageUrl: isPageTitleComponent ? result.urls.full : result.urls.regular,
                smallSizeImageUrl: result.urls.thumb,
                description: result.description,
                downloadLink: result.links.download_location
            }));
    });
}
function $3297a981dc10fa5b$export$d3c50eeab3c808b(downloadLink) {
    (0, $f7B1p.cfetch)(`/wiki/rest/internals/1.0/unsplash/download`, {
        method: 'POST',
        body: JSON.stringify({
            downloadLink: downloadLink
        }),
        headers: {
            'Content-Type': 'application/json'
        }
    });
}


const $b276f472a35f7217$var$styles = {
    addHeaderImageButton: "_tzy4kb7n"
};
const $b276f472a35f7217$export$97958e565d90ce0a = (t0)=>{
    const $ = (0, $frIzR.c)(31);
    const { userOffline: userOffline, openModal: openModal, openMediaBrowser: openMediaBrowser, isModalOpenState: isModalOpenState, closeModal: closeModal, handleUnsplashUpload: handleUnsplashUpload, setIsUploadingPicture: setIsUploadingPicture, initialUnsplashInfoArray: initialUnsplashInfoArray, setInitialUnsplashInfoArray: setInitialUnsplashInfoArray, coverPictureState: coverPictureState, floatingToolbarButtonStyle: floatingToolbarButtonStyle, contentId: contentId, generateAIHeaderImage: generateAIHeaderImage, analyticsSource: t1 } = t0;
    const analyticsSource = t1 === undefined ? "editorPageCoverPicture" : t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isPageTitleComponent = true;
    let t2;
    if ($[0] !== initialUnsplashInfoArray.length || $[1] !== setInitialUnsplashInfoArray) {
        t2 = ()=>{
            if (initialUnsplashInfoArray.length === 0) (0, $3297a981dc10fa5b$export$c23d8af8b1b8f2d7)((0, $2Maq7.PAGE_TITLE_DEFAULT_UNSPLASH_QUERY_WORD), 1, true).then((results)=>{
                setInitialUnsplashInfoArray(results);
            });
        };
        $[0] = initialUnsplashInfoArray.length;
        $[1] = setInitialUnsplashInfoArray;
        $[2] = t2;
    } else t2 = $[2];
    const onAddHeaderImageButtonHovered = t2;
    let t3;
    if ($[3] !== analyticsSource || $[4] !== createAnalyticsEvent || $[5] !== openModal) {
        t3 = ()=>{
            openModal();
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "addHeaderImageButtonClicked",
                    source: analyticsSource
                }
            }).fire();
        };
        $[3] = analyticsSource;
        $[4] = createAnalyticsEvent;
        $[5] = openModal;
        $[6] = t3;
    } else t3 = $[6];
    const onAddHeaderImageButtonClicked = t3;
    let t4;
    if ($[7] !== coverPictureState || $[8] !== isModalOpenState) {
        t4 = ()=>{
            if (!isModalOpenState) coverPictureState.setIsAddHeaderImageButtonFocused(true);
        };
        $[7] = coverPictureState;
        $[8] = isModalOpenState;
        $[9] = t4;
    } else t4 = $[9];
    const handleFocus = t4;
    let t5;
    if ($[10] !== coverPictureState) {
        t5 = ()=>{
            coverPictureState.setIsAddHeaderImageButtonFocused(false);
        };
        $[10] = coverPictureState;
        $[11] = t5;
    } else t5 = $[11];
    const handleBlur = t5;
    let t6;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $gMc0m.default)([
            $b276f472a35f7217$var$styles.addHeaderImageButton
        ]);
        $[12] = t6;
    } else t6 = $[12];
    const t7 = initialUnsplashInfoArray;
    let t8;
    if ($[13] !== closeModal || $[14] !== contentId || $[15] !== coverPictureState || $[16] !== floatingToolbarButtonStyle || $[17] !== generateAIHeaderImage || $[18] !== handleUnsplashUpload || $[19] !== isModalOpenState || $[20] !== onAddHeaderImageButtonClicked || $[21] !== onAddHeaderImageButtonHovered || $[22] !== openMediaBrowser || $[23] !== setIsUploadingPicture || $[24] !== t7 || $[25] !== userOffline) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a391e9da6cc7b48e$export$44d946b74397afda), {
            imageSrc: "",
            initialUnsplashInfoArray: t7,
            openMediaBrowser: openMediaBrowser,
            handleUnsplashUpload: handleUnsplashUpload,
            setIsUploadingPicture: setIsUploadingPicture,
            coverPictureState: coverPictureState,
            closePopup: closeModal,
            userOffline: userOffline,
            floatingToolbarButtonStyle: floatingToolbarButtonStyle,
            isModalOpenState: isModalOpenState,
            onAddHeaderImageButtonClicked: onAddHeaderImageButtonClicked,
            onAddHeaderImageButtonHovered: onAddHeaderImageButtonHovered,
            contentId: contentId,
            generateAIHeaderImage: generateAIHeaderImage
        });
        $[13] = closeModal;
        $[14] = contentId;
        $[15] = coverPictureState;
        $[16] = floatingToolbarButtonStyle;
        $[17] = generateAIHeaderImage;
        $[18] = handleUnsplashUpload;
        $[19] = isModalOpenState;
        $[20] = onAddHeaderImageButtonClicked;
        $[21] = onAddHeaderImageButtonHovered;
        $[22] = openMediaBrowser;
        $[23] = setIsUploadingPicture;
        $[24] = t7;
        $[25] = userOffline;
        $[26] = t8;
    } else t8 = $[26];
    let t9;
    if ($[27] !== handleBlur || $[28] !== handleFocus || $[29] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "add-header-image-button-wrapper",
            onFocus: handleFocus,
            onBlur: handleBlur,
            className: t6
        }, t8);
        $[27] = handleBlur;
        $[28] = handleFocus;
        $[29] = t8;
        $[30] = t9;
    } else t9 = $[30];
    return t9;
};




























const $46b253a18b421305$var$i18n = (0, $aXWIB.defineMessages)({
    dragToReposition: {
        id: "page-cover-picture.drag.to.reposition.message",
        defaultMessage: "Drag to reposition"
    },
    saveReposition: {
        id: "page-cover-picture.save.reposition",
        defaultMessage: "Apply"
    },
    cancelReposition: {
        id: "page-cover-picture.cancel.reposition",
        defaultMessage: "Cancel"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $46b253a18b421305$var$RepositionWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { userOffline: userOffline, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11q7i8nm _1e0c1txw _4cvr1h6o _3um0ewfl _4t3i1ul9 _1bsb1osq",
            __cmplp.userOffline ? "_80om13gf" : "_80om73ad",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $46b253a18b421305$var$DragToRepositionTextWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c81d4k _syaz1j9a _1e0c1txw _1bsb1t1y _1bahesu3",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $46b253a18b421305$var$RepositionButtonText = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c8fhey _syazi7uo",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $46b253a18b421305$var$RepositionButtonWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1bsb1lk2 _1e0c1txw _1bahesu3 _2hwxu2gc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $46b253a18b421305$var$RepositionImageWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(8);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "span" : t2;
        const { userOffline: userOffline, dynamicCoverImageHeight: dynamicCoverImageHeight, ...__cmpldp } = __cmplp;
        const t3 = `${__cmplp.dynamicCoverImageHeight}px`;
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $7sObp.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        let t5;
        if ($[5] !== __cmpls || $[6] !== t4) {
            t5 = {
                ...__cmpls,
                "--_1isxe5u": t4
            };
            $[5] = __cmpls;
            $[6] = t4;
            $[7] = t5;
        } else t5 = $[7];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: t5,
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_kqswh2mm _4t3i1v90 _1bsb1osq _1e0c1txw _4cvr1y6m",
                __cmplp.userOffline ? "_80om13gf" : "_80ommivt",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $46b253a18b421305$export$78e1d98d4f84631f = ({ initialPicturePosition: initialPicturePosition, onSaveReposition: onSaveReposition, setIsRepositionActive: setIsRepositionActive, setShouldShowReposition: setShouldShowReposition, coverPictureState: coverPictureState, forceUpdate: forceUpdate, userOffline: userOffline, dynamicCoverImageHeight: dynamicCoverImageHeight, analyticsSource: analyticsSource = 'editorPageCoverPicture' })=>{
    const userOfflineRef = (0, $42omo.useRef)(userOffline);
    (0, $42omo.useEffect)(()=>{
        userOfflineRef.current = userOffline;
    }, [
        userOffline
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const handleRepositionImageMouseDown = ()=>{
        // if we are here that means reposition is active since the div is visible to the user and user just moused down inside the image
        // they want to reposition
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };
    const handleMouseUp = ()=>{
        removeListeners();
    };
    let oldClientY = 0;
    const curPos = (0, $42omo.useRef)(initialPicturePosition || (0, $75Ax4.DEFAULT_POSITION_VALUE));
    const handleMouseMove = (e)=>{
        if (userOfflineRef.current) {
            removeListeners();
            return;
        }
        e.preventDefault();
        // prevent text selection
        const img = document.getElementById('actual-cover-picture');
        if (!img) return;
        if (e.clientY > oldClientY) // mouse moved down
        {
            if (curPos.current - 0.75 >= 0) {
                curPos.current -= 0.75;
                img.style.objectPosition = `center ${curPos.current}%`;
            }
        } else if (e.clientY < oldClientY) // mouse moved up
        {
            if (curPos.current + 0.75 <= 100) {
                curPos.current += 0.75;
                img.style.objectPosition = `center ${curPos.current}%`;
            }
        }
        oldClientY = e.clientY;
    };
    const removeListeners = ()=>{
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
    };
    const saveReposition = async ()=>{
        coverPictureState.setIsRepositioningPicture(true);
        await onSaveReposition(curPos.current);
        setIsRepositionActive(false);
        setShouldShowReposition(false);
        coverPictureState.setIsRepositioningPicture(false);
        removeListeners();
        await coverPictureState.setIsChangingPicture(false);
        await coverPictureState.setShouldShowReposition(false);
        forceUpdate?.(Math.random());
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'repositionSaveButtonClicked',
                source: analyticsSource,
                attributes: {
                    isLivePage: isLivePage
                }
            }
        }).fire();
    };
    const cancelReposition = async ()=>{
        const img_0 = document.getElementById('actual-cover-picture');
        setIsRepositionActive(false);
        setShouldShowReposition(false);
        coverPictureState.setIsRepositioningPicture(false);
        removeListeners();
        await coverPictureState.setShouldShowReposition(false);
        await coverPictureState.setIsChangingPicture(false);
        forceUpdate?.(Math.random());
        if (img_0) img_0.style.objectPosition = `center ${initialPicturePosition}%`;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'repositionCancelButtonClicked',
                source: analyticsSource
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($46b253a18b421305$var$RepositionImageWrapper, {
        onMouseDown: userOffline ? undefined : handleRepositionImageMouseDown,
        "data-testid": "reposition-div",
        userOffline: userOffline,
        dynamicCoverImageHeight: dynamicCoverImageHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($46b253a18b421305$var$RepositionWrapper, {
        userOffline: userOffline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($46b253a18b421305$var$DragToRepositionTextWrapper, null, formatMessage($46b253a18b421305$var$i18n.dragToReposition)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($46b253a18b421305$var$RepositionButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        testId: "save-reposition-button",
        spacing: "compact",
        onClick: saveReposition,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            background: "var(--ds-background-input, #FFFFFF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginRight: "var(--ds-space-200, 16px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginLeft: "var(--ds-space-negative-100, -8px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginBottom: "var(--ds-space-025, 2px)"
        },
        isDisabled: userOffline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($46b253a18b421305$var$RepositionButtonText, null, formatMessage($46b253a18b421305$var$i18n.saveReposition))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        testId: "cancel-reposition-button",
        spacing: "compact",
        onClick: cancelReposition,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            background: "var(--ds-background-input, #FFFFFF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginBottom: "var(--ds-space-025, 2px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginLeft: "var(--ds-space-negative-050, -4px)"
        },
        isDisabled: userOffline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($46b253a18b421305$var$RepositionButtonText, null, formatMessage($46b253a18b421305$var$i18n.cancelReposition))))));
};


















































const $1bbfbc20e55661d7$var$i18n = (0, $aXWIB.defineMessages)({
    headerLabel: {
        id: "content-topper.add.header.image.message.floating-toolbar",
        defaultMessage: "Header image"
    },
    updateImage: {
        id: "content-topper.page-title.popup.update.header.image",
        defaultMessage: "Update header image"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1bbfbc20e55661d7$var$DropdownTrigger = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "button" : t5;
        const { userOffline: userOffline, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2lx21bp4 _1n261q9c _11q7glyw _19itglyw _1e0c1txw _4cvr1h6o _syaz1j9a _12jivbh5",
            __cmplp.userOffline ? "_80om13gf" : "_80omtlke",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $1bbfbc20e55661d7$export$f190f045ee817cbf = (t0)=>{
    const $ = (0, $frIzR.c)(27);
    const { isModalOpenState: isModalOpenState, closePopup: closePopup, initialUnsplashInfoArray: initialUnsplashInfoArray, openMediaBrowser: openMediaBrowser, userOffline: userOffline, handleUnsplashUpload: handleUnsplashUpload, setIsUploadingPicture: setIsUploadingPicture, coverPictureState: coverPictureState, floatingToolbarButtonStyle: floatingToolbarButtonStyle, onReposition: onReposition, onDelete: onDelete, imageSrc: imageSrc, dropdownRef: dropdownRef, dropdownPopupComponentRef: dropdownPopupComponentRef, contentId: contentId, onImageWidthChange: onImageWidthChange, onCoverImageWidthDropdownOptionSelected: onCoverImageWidthDropdownOptionSelected, generateAIHeaderImage: generateAIHeaderImage } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $g5lKx.layers).dialog();
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== floatingToolbarButtonStyle || $[2] !== isModalOpenState || $[3] !== userOffline) {
        t2 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1bbfbc20e55661d7$var$DropdownTrigger, {
                "data-testid": "update-image-button",
                ...triggerProps,
                tabIndex: 0,
                "aria-expanded": isModalOpenState,
                ref: triggerProps.ref,
                style: floatingToolbarButtonStyle || {},
                userOffline: userOffline,
                disabled: userOffline
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fZtQj))), {
                label: "",
                color: "var(--ds-icon-inverse, #FFFFFF)"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $1bbfbc20e55661d7$var$i18n.updateImage));
        $[1] = floatingToolbarButtonStyle;
        $[2] = isModalOpenState;
        $[3] = userOffline;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== closePopup || $[6] !== contentId || $[7] !== coverPictureState || $[8] !== dropdownPopupComponentRef || $[9] !== dropdownRef || $[10] !== generateAIHeaderImage || $[11] !== handleUnsplashUpload || $[12] !== imageSrc || $[13] !== initialUnsplashInfoArray || $[14] !== onCoverImageWidthDropdownOptionSelected || $[15] !== onDelete || $[16] !== onImageWidthChange || $[17] !== onReposition || $[18] !== openMediaBrowser || $[19] !== setIsUploadingPicture || $[20] !== userOffline) {
        t3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e611c24abe969f89$export$5e27412e512156d4), {
                dropdownRef: dropdownRef,
                contentId: contentId,
                imageSrc: imageSrc,
                initialUnsplashInfoArray: initialUnsplashInfoArray,
                openMediaBrowser: openMediaBrowser,
                handleUnsplashUpload: handleUnsplashUpload,
                setIsUploadingPicture: setIsUploadingPicture,
                coverPictureState: coverPictureState,
                closePopup: closePopup,
                onReposition: onReposition,
                onDelete: onDelete,
                placement: "bottom",
                userOffline: userOffline,
                dropdownPopupComponentRef: dropdownPopupComponentRef,
                onImageWidthChange: onImageWidthChange,
                isPageTitleComponent: true,
                onCoverImageWidthDropdownOptionSelected: onCoverImageWidthDropdownOptionSelected,
                generateAIHeaderImage: generateAIHeaderImage
            });
        $[5] = closePopup;
        $[6] = contentId;
        $[7] = coverPictureState;
        $[8] = dropdownPopupComponentRef;
        $[9] = dropdownRef;
        $[10] = generateAIHeaderImage;
        $[11] = handleUnsplashUpload;
        $[12] = imageSrc;
        $[13] = initialUnsplashInfoArray;
        $[14] = onCoverImageWidthDropdownOptionSelected;
        $[15] = onDelete;
        $[16] = onImageWidthChange;
        $[17] = onReposition;
        $[18] = openMediaBrowser;
        $[19] = setIsUploadingPicture;
        $[20] = userOffline;
        $[21] = t3;
    } else t3 = $[21];
    let t4;
    if ($[22] !== closePopup || $[23] !== isModalOpenState || $[24] !== t2 || $[25] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
            isOpen: isModalOpenState,
            onClose: closePopup,
            placement: "bottom",
            zIndex: t1,
            strategy: "absolute",
            shouldRenderToParent: true,
            role: "dialog",
            trigger: t2,
            content: t3
        });
        $[22] = closePopup;
        $[23] = isModalOpenState;
        $[24] = t2;
        $[25] = t3;
        $[26] = t4;
    } else t4 = $[26];
    return t4;
};



const $d56946553982f95c$var$COVER_IMAGE_FIXED_HEIGHT = 147; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d56946553982f95c$var$HoverOverlay = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { smartSpaceOverviewHeight: smartSpaceOverviewHeight, isFixedWidthImageOption: isFixedWidthImageOption, userOffline: userOffline, isRoundedCorners: isRoundedCorners, isDropdownOpen: isDropdownOpen, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_19y14qn": (0, $7sObp.default)(__cmplp.smartSpaceOverviewHeight, "px")
            },
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_11q7plhp _1bsb1osq _kqswh2mm _1e0c1txw _1bah1h6o _4cvr1h6o",
                __cmplp.smartSpaceOverviewHeight ? "_4t3ihojm" : __cmplp.isFixedWidthImageOption ? "_4t3i2pqz" : "_4t3i6w0c",
                __cmplp.userOffline ? "_80om13gf" : "_80omtlke",
                __cmplp.isRoundedCorners ? "_2rkopb1k" : "_2rko12b0",
                __cmplp.isDropdownOpen ? "_tzy4kb7n" : "_tzy4idpf",
                __cmplp.userOffline ? "_16l4idpf" : "_16l4kb7n",
                __cmplp.userOffline ? "_1mygidpf" : "_1mygkb7n",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $d56946553982f95c$export$d83b52f1c3c4071e = (t0)=>{
    const $ = (0, $frIzR.c)(56);
    const { userOffline: userOffline, closeModal: closeModal, openMediaBrowser: openMediaBrowser, setIsRepositionActive: setIsRepositionActive, onRemoveImage: onRemoveImage, onImageWidthChange: onImageWidthChange, handleUnsplashUpload: handleUnsplashUpload, setIsUploadingPicture: setIsUploadingPicture, initialUnsplashInfoArray: initialUnsplashInfoArray, setInitialUnsplashInfoArray: setInitialUnsplashInfoArray, coverPictureState: coverPictureState, contentId: contentId, dynamicCoverImageHeight: dynamicCoverImageHeight, smartSpaceOverviewHeight: smartSpaceOverviewHeight, isFixedWidthImageOption: isFixedWidthImageOption, generateAIHeaderImage: generateAIHeaderImage, isRoundedCorners: isRoundedCorners, analyticsSource: t1 } = t0;
    const analyticsSource = t1 === undefined ? "editorPageCoverPicture" : t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [isDropdownOpen, setIsDropdownOpen] = (0, $42omo.useState)(false);
    const overlayComponent = (0, $42omo.useRef)(null);
    const dropdownComponent = (0, $42omo.useRef)(null);
    const dropdownPopupComponentRef = (0, $42omo.useRef)(null);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    let t2;
    if ($[0] !== coverPictureState) {
        t2 = (event)=>{
            if (overlayComponent?.current && event.target instanceof Node && !overlayComponent?.current?.contains(event.target) && !dropdownComponent?.current?.contains(event.target) && !dropdownPopupComponentRef?.current?.contains(event.target) && coverPictureState.state.isChangingPicture) {
                coverPictureState.setIsChangingPicture(false);
                setIsDropdownOpen(false);
            }
        };
        $[0] = coverPictureState;
        $[1] = t2;
    } else t2 = $[1];
    const handleClickOutside = t2;
    let t3;
    let t4;
    if ($[2] !== handleClickOutside) {
        t3 = ()=>{
            addEventListener("mousedown", handleClickOutside);
            return ()=>{
                document.removeEventListener("mousedown", handleClickOutside);
            };
        };
        t4 = [
            handleClickOutside
        ];
        $[2] = handleClickOutside;
        $[3] = t3;
        $[4] = t4;
    } else {
        t3 = $[3];
        t4 = $[4];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[5] !== analyticsSource || $[6] !== coverPictureState || $[7] !== createAnalyticsEvent || $[8] !== initialUnsplashInfoArray || $[9] !== isLivePage || $[10] !== setInitialUnsplashInfoArray) {
        t5 = (event_0)=>{
            if (event_0.target instanceof Node && (dropdownComponent?.current?.contains(event_0.target) || dropdownPopupComponentRef?.current?.contains(event_0.target))) return;
            if (initialUnsplashInfoArray.length === 0) (0, $3297a981dc10fa5b$export$c23d8af8b1b8f2d7)((0, $2Maq7.PAGE_TITLE_DEFAULT_UNSPLASH_QUERY_WORD), 1, true).then((results)=>{
                setInitialUnsplashInfoArray(results);
            });
            const isChangingPicture = coverPictureState.state.isChangingPicture;
            coverPictureState.setIsChangingPicture(!isChangingPicture);
            setIsDropdownOpen($d56946553982f95c$var$_temp);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "update",
                    actionSubjectId: "updateHeaderImageButtonClicked",
                    source: analyticsSource,
                    attributes: {
                        isLivePage: isLivePage
                    }
                }
            }).fire();
        };
        $[5] = analyticsSource;
        $[6] = coverPictureState;
        $[7] = createAnalyticsEvent;
        $[8] = initialUnsplashInfoArray;
        $[9] = isLivePage;
        $[10] = setInitialUnsplashInfoArray;
        $[11] = t5;
    } else t5 = $[11];
    const toggleDropdownOpen = t5;
    let t6;
    if ($[12] !== analyticsSource || $[13] !== coverPictureState || $[14] !== createAnalyticsEvent || $[15] !== setIsRepositionActive) {
        t6 = ()=>{
            setIsRepositionActive(true);
            coverPictureState.setIsChangingPicture(false);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "reposition",
                    actionSubjectId: "repositionHeaderImageButtonClicked",
                    source: analyticsSource
                }
            }).fire();
        };
        $[12] = analyticsSource;
        $[13] = coverPictureState;
        $[14] = createAnalyticsEvent;
        $[15] = setIsRepositionActive;
        $[16] = t6;
    } else t6 = $[16];
    const onRepositionClicked = t6;
    let t7;
    if ($[17] !== analyticsSource || $[18] !== coverPictureState.state.isCurrentAIFCAutoImage || $[19] !== createAnalyticsEvent || $[20] !== experienceTracker || $[21] !== isLivePage || $[22] !== onRemoveImage) {
        t7 = ()=>{
            const removedAIFCAutoGeneratedImage = coverPictureState.state.isCurrentAIFCAutoImage;
            experienceTracker.start({
                name: (0, $irVI7.COVER_PICTURE_REMOVE_EXPERIENCE)
            });
            onRemoveImage();
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "remove",
                    actionSubjectId: "removeHeaderImageButtonClicked",
                    source: analyticsSource,
                    attributes: {
                        isLivePage: isLivePage,
                        removedAIFCAutoGeneratedImage: removedAIFCAutoGeneratedImage
                    }
                }
            }).fire();
        };
        $[17] = analyticsSource;
        $[18] = coverPictureState.state.isCurrentAIFCAutoImage;
        $[19] = createAnalyticsEvent;
        $[20] = experienceTracker;
        $[21] = isLivePage;
        $[22] = onRemoveImage;
        $[23] = t7;
    } else t7 = $[23];
    const onRemoveImageClicked = t7;
    let t8;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = (isCoverImageWidthChanged)=>{
            if (isCoverImageWidthChanged) setIsDropdownOpen(false);
        };
        $[24] = t8;
    } else t8 = $[24];
    const onCoverImageWidthDropdownOptionSelected = t8;
    let t9;
    if ($[25] !== coverPictureState) {
        t9 = ()=>{
            coverPictureState.setIsAddHeaderImageButtonFocused(true);
        };
        $[25] = coverPictureState;
        $[26] = t9;
    } else t9 = $[26];
    const handleFocus = t9;
    let t10;
    if ($[27] !== coverPictureState) {
        t10 = ()=>{
            coverPictureState.setIsAddHeaderImageButtonFocused(false);
        };
        $[27] = coverPictureState;
        $[28] = t10;
    } else t10 = $[28];
    const handleBlur = t10;
    const t11 = userOffline ? undefined : toggleDropdownOpen;
    let t12;
    if ($[29] !== closeModal || $[30] !== contentId || $[31] !== coverPictureState || $[32] !== generateAIHeaderImage || $[33] !== handleUnsplashUpload || $[34] !== initialUnsplashInfoArray || $[35] !== isDropdownOpen || $[36] !== onImageWidthChange || $[37] !== onRemoveImageClicked || $[38] !== onRepositionClicked || $[39] !== openMediaBrowser || $[40] !== setIsUploadingPicture || $[41] !== userOffline) {
        t12 = !userOffline && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1bbfbc20e55661d7$export$f190f045ee817cbf), {
            dropdownRef: dropdownComponent,
            onDelete: onRemoveImageClicked,
            onReposition: onRepositionClicked,
            imageSrc: coverPictureState.state.coverPictureId,
            isModalOpenState: isDropdownOpen,
            openMediaBrowser: openMediaBrowser,
            initialUnsplashInfoArray: initialUnsplashInfoArray,
            closePopup: closeModal,
            userOffline: userOffline,
            handleUnsplashUpload: handleUnsplashUpload,
            setIsUploadingPicture: setIsUploadingPicture,
            coverPictureState: coverPictureState,
            dropdownPopupComponentRef: dropdownPopupComponentRef,
            contentId: contentId,
            onImageWidthChange: onImageWidthChange,
            onCoverImageWidthDropdownOptionSelected: onCoverImageWidthDropdownOptionSelected,
            generateAIHeaderImage: generateAIHeaderImage
        });
        $[29] = closeModal;
        $[30] = contentId;
        $[31] = coverPictureState;
        $[32] = generateAIHeaderImage;
        $[33] = handleUnsplashUpload;
        $[34] = initialUnsplashInfoArray;
        $[35] = isDropdownOpen;
        $[36] = onImageWidthChange;
        $[37] = onRemoveImageClicked;
        $[38] = onRepositionClicked;
        $[39] = openMediaBrowser;
        $[40] = setIsUploadingPicture;
        $[41] = userOffline;
        $[42] = t12;
    } else t12 = $[42];
    let t13;
    if ($[43] !== dynamicCoverImageHeight || $[44] !== isDropdownOpen || $[45] !== isFixedWidthImageOption || $[46] !== isRoundedCorners || $[47] !== smartSpaceOverviewHeight || $[48] !== t11 || $[49] !== t12 || $[50] !== userOffline) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d56946553982f95c$var$HoverOverlay, {
            "data-testid": "hover-overlay-custom-sites",
            isDropdownOpen: isDropdownOpen,
            onClick: t11,
            ref: overlayComponent,
            userOffline: userOffline,
            dynamicCoverImageHeight: dynamicCoverImageHeight,
            smartSpaceOverviewHeight: smartSpaceOverviewHeight,
            isFixedWidthImageOption: isFixedWidthImageOption,
            isRoundedCorners: isRoundedCorners,
            className: "cover-picture-wrapper-dangerously-set-inner-html"
        }, t12);
        $[43] = dynamicCoverImageHeight;
        $[44] = isDropdownOpen;
        $[45] = isFixedWidthImageOption;
        $[46] = isRoundedCorners;
        $[47] = smartSpaceOverviewHeight;
        $[48] = t11;
        $[49] = t12;
        $[50] = userOffline;
        $[51] = t13;
    } else t13 = $[51];
    let t14;
    if ($[52] !== handleBlur || $[53] !== handleFocus || $[54] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            onFocus: handleFocus,
            onBlur: handleBlur
        }, t13);
        $[52] = handleBlur;
        $[53] = handleFocus;
        $[54] = t13;
        $[55] = t14;
    } else t14 = $[55];
    return t14;
};
function $d56946553982f95c$var$_temp(prevIsDropdownOpen) {
    return !prevIsDropdownOpen;
}































const $07a01d3f99018a4a$var$i18n = (0, $aXWIB.defineMessages)({
    dragToReposition: {
        id: "page-cover-picture.ai-acceptance.drag.to.reposition.message",
        defaultMessage: "Drag to reposition"
    },
    accept: {
        id: "page-cover-picture.ai-acceptance.accept",
        defaultMessage: "Accept"
    },
    discard: {
        id: "page-cover-picture.ai-acceptance.discard",
        defaultMessage: "Discard"
    },
    retry: {
        id: "page-cover-picture.ai-acceptance.retry",
        defaultMessage: "Retry"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $07a01d3f99018a4a$var$RepositionWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { userOffline: userOffline, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11q7i8nm _1e0c1txw _4cvr1h6o _1bah1yb4 _3um0ewfl _4t3i1ylp _1bsb1osq _19bvpxbi _u5f3pxbi",
            __cmplp.userOffline ? "_80om13gf" : "_80om73ad",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $07a01d3f99018a4a$var$DragToRepositionTextWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c81d4k _syaz1j9a _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $07a01d3f99018a4a$var$ButtonText = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c8fhey _syazi7uo",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $07a01d3f99018a4a$var$AcceptButtonText = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c8fhey _syaz15cr",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $07a01d3f99018a4a$var$ButtonGroup = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_zulpu2gc _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $07a01d3f99018a4a$var$RepositionImageWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(8);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "span" : t2;
        const { userOffline: userOffline, dynamicCoverImageHeight: dynamicCoverImageHeight, ...__cmpldp } = __cmplp;
        const t3 = `${__cmplp.dynamicCoverImageHeight}px`;
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $7sObp.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        let t5;
        if ($[5] !== __cmpls || $[6] !== t4) {
            t5 = {
                ...__cmpls,
                "--_1isxe5u": t4
            };
            $[5] = __cmpls;
            $[6] = t4;
            $[7] = t5;
        } else t5 = $[7];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: t5,
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_kqswh2mm _4t3i1v90 _1bsb1osq _1e0c1txw _4cvr1y6m",
                __cmplp.userOffline ? "_80om13gf" : "_80ommivt",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $07a01d3f99018a4a$export$33aaeca88e7c46bf = ({ initialPicturePosition: initialPicturePosition, onSaveReposition: onSaveReposition, onAccept: onAccept, onDiscard: onDiscard, onRetry: onRetry, isRetrying: isRetrying, coverPictureState: coverPictureState, forceUpdate: forceUpdate, userOffline: userOffline, dynamicCoverImageHeight: dynamicCoverImageHeight, analyticsSource: analyticsSource = 'editorPageCoverPicture' })=>{
    const userOfflineRef = (0, $42omo.useRef)(userOffline);
    (0, $42omo.useEffect)(()=>{
        userOfflineRef.current = userOffline;
    }, [
        userOffline
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const handleRepositionImageMouseDown = ()=>{
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };
    const handleMouseUp = ()=>{
        removeListeners();
    };
    let oldClientY = 0;
    const curPos = (0, $42omo.useRef)(initialPicturePosition || (0, $75Ax4.DEFAULT_POSITION_VALUE));
    const handleMouseMove = (e)=>{
        if (userOfflineRef.current) {
            removeListeners();
            return;
        }
        e.preventDefault();
        const img = document.getElementById('actual-cover-picture');
        if (!img) return;
        if (e.clientY > oldClientY) {
            if (curPos.current - 0.75 >= 0) {
                curPos.current -= 0.75;
                img.style.objectPosition = `center ${curPos.current}%`;
            }
        } else if (e.clientY < oldClientY) {
            if (curPos.current + 0.75 <= 100) {
                curPos.current += 0.75;
                img.style.objectPosition = `center ${curPos.current}%`;
            }
        }
        oldClientY = e.clientY;
    };
    const removeListeners = ()=>{
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
    };
    const handleAccept = async ()=>{
        coverPictureState.setIsRepositioningPicture(true);
        await onSaveReposition(curPos.current);
        coverPictureState.setIsRepositioningPicture(false);
        removeListeners();
        onAccept();
        await coverPictureState.setIsChangingPicture(false);
        forceUpdate?.(Date.now());
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiImageAcceptanceAcceptButtonClicked',
                source: analyticsSource,
                attributes: {
                    isLivePage: isLivePage,
                    position: curPos.current
                }
            }
        }).fire();
    };
    const handleDiscard = async ()=>{
        removeListeners();
        await coverPictureState.setIsChangingPicture(false);
        forceUpdate?.(Date.now());
        onDiscard();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiImageAcceptanceDiscardButtonClicked',
                source: analyticsSource,
                attributes: {
                    isLivePage: isLivePage
                }
            }
        }).fire();
    };
    const handleRetry = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiImageAcceptanceRetryButtonClicked',
                source: analyticsSource,
                attributes: {
                    isLivePage: isLivePage
                }
            }
        }).fire();
        onRetry();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($07a01d3f99018a4a$var$RepositionImageWrapper, {
        onMouseDown: userOffline ? undefined : handleRepositionImageMouseDown,
        "data-testid": "ai-image-acceptance-repositioner",
        userOffline: userOffline,
        dynamicCoverImageHeight: dynamicCoverImageHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($07a01d3f99018a4a$var$RepositionWrapper, {
        userOffline: userOffline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($07a01d3f99018a4a$var$DragToRepositionTextWrapper, null, formatMessage($07a01d3f99018a4a$var$i18n.dragToReposition)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($07a01d3f99018a4a$var$ButtonGroup, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        testId: "ai-image-discard-button",
        spacing: "compact",
        onClick: handleDiscard,
        isDisabled: userOffline || isRetrying,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            background: "var(--ds-background-input, #FFFFFF)"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($07a01d3f99018a4a$var$ButtonText, null, formatMessage($07a01d3f99018a4a$var$i18n.discard))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        testId: "ai-image-retry-button",
        spacing: "compact",
        onClick: handleRetry,
        isDisabled: userOffline || isRetrying,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            background: "var(--ds-background-input, #FFFFFF)"
        }
    }, isRetrying ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($07a01d3f99018a4a$var$ButtonText, null, formatMessage($07a01d3f99018a4a$var$i18n.retry))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        testId: "ai-image-accept-button",
        spacing: "compact",
        appearance: "primary",
        onClick: handleAccept,
        isDisabled: userOffline || isRetrying
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($07a01d3f99018a4a$var$AcceptButtonText, null, formatMessage($07a01d3f99018a4a$var$i18n.accept))))));
};


// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $689140bd887be349$var$UploadingPictureWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(8);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { smartSpaceOverviewHeight: smartSpaceOverviewHeight, dynamicCoverImageHeight: dynamicCoverImageHeight, ...__cmpldp } = __cmplp;
        const t3 = `${__cmplp.smartSpaceOverviewHeight ?? __cmplp.dynamicCoverImageHeight}px`;
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $7sObp.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        let t5;
        if ($[5] !== __cmpls || $[6] !== t4) {
            t5 = {
                ...__cmpls,
                "--_13y1ha6": t4
            };
            $[5] = __cmpls;
            $[6] = t4;
            $[7] = t5;
        } else t5 = $[7];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: t5,
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_11q7ysee _2rkofajl _1bsb1osq _4t3i144s _kqswh2mm _1e0c1txw _1bah1h6o _4cvr1h6o",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $689140bd887be349$export$4103f8c62b69a0b3 = /*#__PURE__*/ (0, $42omo.memo)((t0)=>{
    const $ = (0, $frIzR.c)(63);
    const { hasCoverPicture: hasCoverPicture, openMediaBrowser: openMediaBrowser, onRemoveImage: onRemoveImage, userOffline: userOffline, setIsUploadingPicture: setIsUploadingPicture, isUploadingPicture: isUploadingPicture, handleUnsplashUpload: handleUnsplashUpload, initialPicturePosition: initialPicturePosition, onSaveReposition: onSaveReposition, shouldShowReposition: shouldShowReposition, setShouldShowReposition: setShouldShowReposition, coverPictureState: coverPictureState, floatingToolbarButtonStyle: floatingToolbarButtonStyle, forceUpdate: forceUpdate, contentId: contentId, dynamicCoverImageHeight: dynamicCoverImageHeight, smartSpaceOverviewHeight: smartSpaceOverviewHeight, onImageWidthChange: onImageWidthChange, spaceKey: spaceKey, isFixedWidthImageOption: isFixedWidthImageOption, generateAIHeaderImage: generateAIHeaderImage, shouldShowAIImageAcceptanceFlow: shouldShowAIImageAcceptanceFlow, onAcceptAIGeneratedImage: onAcceptAIGeneratedImage, onRetryAIGeneratedImage: onRetryAIGeneratedImage, isRetryingAIImage: isRetryingAIImage, isRoundedCorners: isRoundedCorners, analyticsSource: analyticsSource } = t0;
    const [isModalOpenState, setIsModalOpenState] = (0, $42omo.useState)(false);
    const [isRepositionActive, setIsRepositionActive] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [initialUnsplashInfoArray, setInitialUnsplashInfoArray] = (0, $42omo.useState)(t1);
    let t2;
    if ($[1] !== coverPictureState) {
        t2 = ()=>{
            setIsModalOpenState(true);
            coverPictureState.setIsModalOpen(true);
        };
        $[1] = coverPictureState;
        $[2] = t2;
    } else t2 = $[2];
    const openModal = t2;
    let t3;
    if ($[3] !== coverPictureState) {
        t3 = ()=>{
            setIsModalOpenState(false);
            coverPictureState.setIsModalOpen(false);
        };
        $[3] = coverPictureState;
        $[4] = t3;
    } else t3 = $[4];
    const closeModal = t3;
    if (isUploadingPicture && coverPictureState.state.isUploadingPicture) {
        let t4;
        if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
                size: "medium"
            });
            $[5] = t4;
        } else t4 = $[5];
        let t5;
        if ($[6] !== dynamicCoverImageHeight || $[7] !== hasCoverPicture || $[8] !== smartSpaceOverviewHeight) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($689140bd887be349$var$UploadingPictureWrapper, {
                "data-testid": "uploading-picture-wrapper",
                hasCoverPicture: hasCoverPicture,
                dynamicCoverImageHeight: dynamicCoverImageHeight,
                smartSpaceOverviewHeight: smartSpaceOverviewHeight
            }, t4);
            $[6] = dynamicCoverImageHeight;
            $[7] = hasCoverPicture;
            $[8] = smartSpaceOverviewHeight;
            $[9] = t5;
        } else t5 = $[9];
        return t5;
    } else if (shouldShowAIImageAcceptanceFlow && hasCoverPicture) {
        let t4;
        if ($[10] !== analyticsSource || $[11] !== coverPictureState || $[12] !== dynamicCoverImageHeight || $[13] !== forceUpdate || $[14] !== initialPicturePosition || $[15] !== isRetryingAIImage || $[16] !== onAcceptAIGeneratedImage || $[17] !== onRemoveImage || $[18] !== onRetryAIGeneratedImage || $[19] !== onSaveReposition || $[20] !== userOffline) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $07a01d3f99018a4a$export$33aaeca88e7c46bf), {
                initialPicturePosition: initialPicturePosition,
                onSaveReposition: onSaveReposition,
                onAccept: onAcceptAIGeneratedImage,
                onDiscard: onRemoveImage,
                onRetry: onRetryAIGeneratedImage,
                isRetrying: isRetryingAIImage,
                coverPictureState: coverPictureState,
                forceUpdate: forceUpdate,
                userOffline: userOffline,
                dynamicCoverImageHeight: dynamicCoverImageHeight,
                analyticsSource: analyticsSource
            });
            $[10] = analyticsSource;
            $[11] = coverPictureState;
            $[12] = dynamicCoverImageHeight;
            $[13] = forceUpdate;
            $[14] = initialPicturePosition;
            $[15] = isRetryingAIImage;
            $[16] = onAcceptAIGeneratedImage;
            $[17] = onRemoveImage;
            $[18] = onRetryAIGeneratedImage;
            $[19] = onSaveReposition;
            $[20] = userOffline;
            $[21] = t4;
        } else t4 = $[21];
        return t4;
    } else {
        if ((isRepositionActive || shouldShowReposition || !!coverPictureState.state.shouldShowReposition) && hasCoverPicture) {
            let t4;
            if ($[22] !== analyticsSource || $[23] !== coverPictureState || $[24] !== dynamicCoverImageHeight || $[25] !== forceUpdate || $[26] !== initialPicturePosition || $[27] !== onSaveReposition || $[28] !== setShouldShowReposition || $[29] !== userOffline) {
                t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $46b253a18b421305$export$78e1d98d4f84631f), {
                    initialPicturePosition: initialPicturePosition,
                    onSaveReposition: onSaveReposition,
                    setIsRepositionActive: setIsRepositionActive,
                    setShouldShowReposition: setShouldShowReposition,
                    coverPictureState: coverPictureState,
                    forceUpdate: forceUpdate,
                    userOffline: userOffline,
                    dynamicCoverImageHeight: dynamicCoverImageHeight,
                    analyticsSource: analyticsSource
                });
                $[22] = analyticsSource;
                $[23] = coverPictureState;
                $[24] = dynamicCoverImageHeight;
                $[25] = forceUpdate;
                $[26] = initialPicturePosition;
                $[27] = onSaveReposition;
                $[28] = setShouldShowReposition;
                $[29] = userOffline;
                $[30] = t4;
            } else t4 = $[30];
            return t4;
        } else if (hasCoverPicture) {
            let t4;
            if ($[31] !== analyticsSource || $[32] !== closeModal || $[33] !== contentId || $[34] !== coverPictureState || $[35] !== dynamicCoverImageHeight || $[36] !== generateAIHeaderImage || $[37] !== handleUnsplashUpload || $[38] !== initialUnsplashInfoArray || $[39] !== isFixedWidthImageOption || $[40] !== isRoundedCorners || $[41] !== onImageWidthChange || $[42] !== onRemoveImage || $[43] !== openMediaBrowser || $[44] !== setIsUploadingPicture || $[45] !== smartSpaceOverviewHeight || $[46] !== spaceKey || $[47] !== userOffline) {
                t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d56946553982f95c$export$d83b52f1c3c4071e), {
                    userOffline: userOffline,
                    closeModal: closeModal,
                    openMediaBrowser: openMediaBrowser,
                    setIsRepositionActive: setIsRepositionActive,
                    onRemoveImage: onRemoveImage,
                    handleUnsplashUpload: handleUnsplashUpload,
                    setIsUploadingPicture: setIsUploadingPicture,
                    initialUnsplashInfoArray: initialUnsplashInfoArray,
                    setInitialUnsplashInfoArray: setInitialUnsplashInfoArray,
                    coverPictureState: coverPictureState,
                    contentId: contentId,
                    onImageWidthChange: onImageWidthChange,
                    spaceKey: spaceKey,
                    dynamicCoverImageHeight: dynamicCoverImageHeight,
                    smartSpaceOverviewHeight: smartSpaceOverviewHeight,
                    isFixedWidthImageOption: isFixedWidthImageOption,
                    generateAIHeaderImage: generateAIHeaderImage,
                    isRoundedCorners: isRoundedCorners,
                    analyticsSource: analyticsSource
                });
                $[31] = analyticsSource;
                $[32] = closeModal;
                $[33] = contentId;
                $[34] = coverPictureState;
                $[35] = dynamicCoverImageHeight;
                $[36] = generateAIHeaderImage;
                $[37] = handleUnsplashUpload;
                $[38] = initialUnsplashInfoArray;
                $[39] = isFixedWidthImageOption;
                $[40] = isRoundedCorners;
                $[41] = onImageWidthChange;
                $[42] = onRemoveImage;
                $[43] = openMediaBrowser;
                $[44] = setIsUploadingPicture;
                $[45] = smartSpaceOverviewHeight;
                $[46] = spaceKey;
                $[47] = userOffline;
                $[48] = t4;
            } else t4 = $[48];
            return t4;
        } else {
            let t4;
            if ($[49] !== analyticsSource || $[50] !== closeModal || $[51] !== contentId || $[52] !== coverPictureState || $[53] !== floatingToolbarButtonStyle || $[54] !== generateAIHeaderImage || $[55] !== handleUnsplashUpload || $[56] !== initialUnsplashInfoArray || $[57] !== isModalOpenState || $[58] !== openMediaBrowser || $[59] !== openModal || $[60] !== setIsUploadingPicture || $[61] !== userOffline) {
                t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b276f472a35f7217$export$97958e565d90ce0a), {
                    userOffline: userOffline,
                    openModal: openModal,
                    closeModal: closeModal,
                    openMediaBrowser: openMediaBrowser,
                    isModalOpenState: isModalOpenState,
                    handleUnsplashUpload: handleUnsplashUpload,
                    setIsUploadingPicture: setIsUploadingPicture,
                    initialUnsplashInfoArray: initialUnsplashInfoArray,
                    setInitialUnsplashInfoArray: setInitialUnsplashInfoArray,
                    coverPictureState: coverPictureState,
                    floatingToolbarButtonStyle: floatingToolbarButtonStyle,
                    contentId: contentId,
                    generateAIHeaderImage: generateAIHeaderImage,
                    analyticsSource: analyticsSource
                });
                $[49] = analyticsSource;
                $[50] = closeModal;
                $[51] = contentId;
                $[52] = coverPictureState;
                $[53] = floatingToolbarButtonStyle;
                $[54] = generateAIHeaderImage;
                $[55] = handleUnsplashUpload;
                $[56] = initialUnsplashInfoArray;
                $[57] = isModalOpenState;
                $[58] = openMediaBrowser;
                $[59] = openModal;
                $[60] = setIsUploadingPicture;
                $[61] = userOffline;
                $[62] = t4;
            } else t4 = $[62];
            return t4;
        }
    }
});




















const $4dbf19c0ece58c9f$var$styles = {
    base: "_1e0c1txw _1bsb1osq _kqswstnw",
    loading: "_kqswh2mm _1bsb1osq _bfhkysee",
    noOpacity: "_tzy4idpf",
    opacity: "_tzy4kb7n"
}; // TODO: remove when cleaning up confluence_page_cover_picture_css_migration
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4dbf19c0ece58c9f$var$AllowedExternalLoadingDivStyled = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { smartSpaceOverviewHeight: smartSpaceOverviewHeight, dynamicCoverImageHeight: dynamicCoverImageHeight, hasAllowedExternalImageLoaded: hasAllowedExternalImageLoaded, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_19y14qn": (0, $7sObp.default)(__cmplp.smartSpaceOverviewHeight, "px"),
                "--_pjvxvw": (0, $7sObp.default)(__cmplp.dynamicCoverImageHeight, "px")
            },
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_11q7ysee _2rkon7od _kqswh2mm _1bsb1osq",
                __cmplp.smartSpaceOverviewHeight ? "_4t3ihojm" : "_4t3ifmv9",
                __cmplp.hasAllowedExternalImageLoaded ? "_tzy4idpf" : "_tzy4kb7n",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $4dbf19c0ece58c9f$var$getMinHeightStyle = (isFixedWidthImageOption, smartSpaceOverviewHeight)=>{
    if (smartSpaceOverviewHeight) return `${smartSpaceOverviewHeight}px`;
    if (isFixedWidthImageOption) // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    return `${0, $75Ax4.COVER_IMAGE_FIXED_HEIGHT}px`;
     // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    return `${0, $75Ax4.CALCULATE_SCALED_COVER_IMAGE_HEIGHT_FOR_EDIT_PAGE}px`;
};
const $4dbf19c0ece58c9f$var$AllowedExternalWrapper = (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { isFixedWidthImageOption: isFixedWidthImageOption, smartSpaceOverviewHeight: smartSpaceOverviewHeight, children: children } = t0;
    let t1;
    if ($[0] !== isFixedWidthImageOption || $[1] !== smartSpaceOverviewHeight) {
        t1 = $4dbf19c0ece58c9f$var$getMinHeightStyle(isFixedWidthImageOption, smartSpaceOverviewHeight);
        $[0] = isFixedWidthImageOption;
        $[1] = smartSpaceOverviewHeight;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== t1) {
        t2 = {
            minHeight: t1
        };
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $gMc0m.default)([
            $4dbf19c0ece58c9f$var$styles.base
        ]);
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== children || $[7] !== t2) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: t2,
            "data-testid": "unsplash-wrapper-css",
            className: t3
        }, children);
        $[6] = children;
        $[7] = t2;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
};
const $4dbf19c0ece58c9f$var$AllowedExternalLoadingDiv = (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { hasAllowedExternalImageLoaded: hasAllowedExternalImageLoaded, dynamicCoverImageHeight: dynamicCoverImageHeight, smartSpaceOverviewHeight: smartSpaceOverviewHeight } = t0;
    if ((0, $6mKj3.expValEquals)("confluence_page_cover_picture_css_migration", "isEnabled", true)) {
        const t1 = smartSpaceOverviewHeight ? `${smartSpaceOverviewHeight}px` : dynamicCoverImageHeight ? `${dynamicCoverImageHeight}px` : undefined;
        let t2;
        if ($[0] !== t1) {
            t2 = {
                height: t1
            };
            $[0] = t1;
            $[1] = t2;
        } else t2 = $[1];
        const t3 = hasAllowedExternalImageLoaded ? $4dbf19c0ece58c9f$var$styles.noOpacity : $4dbf19c0ece58c9f$var$styles.opacity;
        let t4;
        if ($[2] !== t3) {
            t4 = (0, $gMc0m.default)([
                $4dbf19c0ece58c9f$var$styles.loading,
                t3
            ]);
            $[2] = t3;
            $[3] = t4;
        } else t4 = $[3];
        let t5;
        if ($[4] !== t2 || $[5] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                style: t2,
                "data-testid": "unsplash-loading-div-css",
                className: t4
            });
            $[4] = t2;
            $[5] = t4;
            $[6] = t5;
        } else t5 = $[6];
        return t5;
    }
    let t1;
    if ($[7] !== dynamicCoverImageHeight || $[8] !== hasAllowedExternalImageLoaded || $[9] !== smartSpaceOverviewHeight) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4dbf19c0ece58c9f$var$AllowedExternalLoadingDivStyled, {
            hasAllowedExternalImageLoaded: hasAllowedExternalImageLoaded,
            dynamicCoverImageHeight: dynamicCoverImageHeight,
            smartSpaceOverviewHeight: smartSpaceOverviewHeight,
            "data-testid": "unsplash-loading-div"
        });
        $[7] = dynamicCoverImageHeight;
        $[8] = hasAllowedExternalImageLoaded;
        $[9] = smartSpaceOverviewHeight;
        $[10] = t1;
    } else t1 = $[10];
    return t1;
};
const $4dbf19c0ece58c9f$export$8e0ec3f3e7cffe52 = (t0)=>{
    const $ = (0, $frIzR.c)(18);
    const { coverPicture: coverPicture, dynamicCoverImageHeight: dynamicCoverImageHeight, isFixedWidthImageOption: isFixedWidthImageOption, smartSpaceOverviewHeight: smartSpaceOverviewHeight, coverPictureDataPosition: coverPictureDataPosition, coverPictureDataId: coverPictureDataId, isRoundedCorners: isRoundedCorners } = t0;
    const [hasAllowedExternalImageLoaded, setHasAllowedExternalImageLoaded] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] !== dynamicCoverImageHeight || $[1] !== hasAllowedExternalImageLoaded || $[2] !== smartSpaceOverviewHeight) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4dbf19c0ece58c9f$var$AllowedExternalLoadingDiv, {
            hasAllowedExternalImageLoaded: hasAllowedExternalImageLoaded,
            dynamicCoverImageHeight: dynamicCoverImageHeight,
            smartSpaceOverviewHeight: smartSpaceOverviewHeight
        });
        $[0] = dynamicCoverImageHeight;
        $[1] = hasAllowedExternalImageLoaded;
        $[2] = smartSpaceOverviewHeight;
        $[3] = t1;
    } else t1 = $[3];
    const t2 = coverPicture.current.draft?.value.id ?? coverPictureDataId;
    const t3 = coverPicture.current.draft?.value.position ?? coverPictureDataPosition;
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            setHasAllowedExternalImageLoaded(true);
        };
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== isFixedWidthImageOption || $[6] !== isRoundedCorners || $[7] !== smartSpaceOverviewHeight || $[8] !== t2 || $[9] !== t3) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $66db09fad5336912$export$75f07c36086c2c81), {
            "data-testid": "unsplash-cover-picture",
            id: "actual-cover-picture",
            "data-vc": "unsplash-cover-picture-editor",
            src: t2,
            coverPicturePosition: t3,
            onLoad: t4,
            isFixedWidthImageOption: isFixedWidthImageOption,
            smartSpaceOverviewHeight: smartSpaceOverviewHeight,
            isRoundedCorners: isRoundedCorners,
            className: "cover-picture-wrapper-dangerously-set-inner-html"
        });
        $[5] = isFixedWidthImageOption;
        $[6] = isRoundedCorners;
        $[7] = smartSpaceOverviewHeight;
        $[8] = t2;
        $[9] = t3;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== dynamicCoverImageHeight || $[12] !== hasAllowedExternalImageLoaded || $[13] !== isFixedWidthImageOption || $[14] !== smartSpaceOverviewHeight || $[15] !== t1 || $[16] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4dbf19c0ece58c9f$var$AllowedExternalWrapper, {
            hasAllowedExternalImageLoaded: hasAllowedExternalImageLoaded,
            dynamicCoverImageHeight: dynamicCoverImageHeight,
            isFixedWidthImageOption: isFixedWidthImageOption,
            smartSpaceOverviewHeight: smartSpaceOverviewHeight,
            "data-testid": "unsplash-wrapper"
        }, t1, t5);
        $[11] = dynamicCoverImageHeight;
        $[12] = hasAllowedExternalImageLoaded;
        $[13] = isFixedWidthImageOption;
        $[14] = smartSpaceOverviewHeight;
        $[15] = t1;
        $[16] = t5;
        $[17] = t6;
    } else t6 = $[17];
    return t6;
};











/* EditorPageCoverPictureWrapperCss.tsx generated by @compiled/babel-plugin v0.36.1 */ 





const $27bd5511d1f80242$var$COVER_IMAGE_FIXED_HEIGHT = 147;
const $27bd5511d1f80242$var$SMART_SPACE_OVERVIEW_FIXED_HEIGHT_FULL_WIDTH = 200;
const $27bd5511d1f80242$var$styles = {
    base: "_kqswh2mm _otyru2gc",
    noMargin: "_19pkze3t _otyrze3t",
    pointer: "_80omtlke",
    auto: "_80om1wug",
    withPicture: "_19pk12x7",
    withoutPicture: "_19pkze3t",
    hidden: "_4t3iidpf",
    fixedWidth: "_4t3i2pqz",
    smartSpaceOverviewHeight: "_4t3iuuw1",
    scaledWidth: "_4t3i6w0c"
};
const $27bd5511d1f80242$export$67a89e1eb110a1d7 = ({ hasCoverPicture: hasCoverPicture, isUploadingPicture: isUploadingPicture, isReadOnly: isReadOnly, isFixedWidthImageOption: isFixedWidthImageOption, isSmartSpaceOverview: isSmartSpaceOverview, width: width, children: children, ...props })=>{
    'use no memo'; // Exclude from React compiler - breaks unit tests when component uses compiled CSS
    // Dynamic width - must use style prop
    const computedWidth = (0, $42omo.useMemo)(()=>{
        if ((hasCoverPicture || isUploadingPicture) && isFixedWidthImageOption) return '800px';
        if ((hasCoverPicture || isUploadingPicture) && !isFixedWidthImageOption) return '100%';
        if ((hasCoverPicture || isUploadingPicture) && width) return `${width}px`;
        return '100%';
    }, [
        hasCoverPicture,
        isUploadingPicture,
        isFixedWidthImageOption,
        width
    ]);
    const hasPicture = hasCoverPicture || isUploadingPicture;
    const showPictureMargin = !isSmartSpaceOverview && hasPicture;
    const showNoPictureMargin = !isSmartSpaceOverview && !hasPicture;
    return /*#__PURE__*/ $42omo.createElement("div", {
        ...props,
        style: {
            width: computedWidth
        },
        className: (0, $gMc0m.default)([
            $27bd5511d1f80242$var$styles.base,
            isSmartSpaceOverview && $27bd5511d1f80242$var$styles.noMargin,
            isReadOnly ? $27bd5511d1f80242$var$styles.auto : $27bd5511d1f80242$var$styles.pointer,
            showPictureMargin && $27bd5511d1f80242$var$styles.withPicture,
            showNoPictureMargin && $27bd5511d1f80242$var$styles.withoutPicture,
            !hasPicture ? $27bd5511d1f80242$var$styles.hidden : isSmartSpaceOverview ? $27bd5511d1f80242$var$styles.smartSpaceOverviewHeight : isFixedWidthImageOption ? $27bd5511d1f80242$var$styles.fixedWidth : $27bd5511d1f80242$var$styles.scaledWidth
        ])
    }, children);
};













const $ae649144a67a3966$var$COVER_IMAGE_FIXED_HEIGHT = 147;
const $ae649144a67a3966$export$825ca283ddb318c2 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { hasCoverPicture: hasCoverPicture, isUploadingPicture: isUploadingPicture, smartSpaceOverviewHeight: smartSpaceOverviewHeight, isFixedWidthImageOption: isFixedWidthImageOption, dynamicCoverImageHeight: dynamicCoverImageHeight, isReadOnly: isReadOnly, isSmartSpaceOverview: isSmartSpaceOverview, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ $42omo.createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_19y14qn": (0, $7sObp.default)(__cmplp.smartSpaceOverviewHeight, "px"),
                "--_pjvxvw": (0, $7sObp.default)(__cmplp.dynamicCoverImageHeight, "px"),
                "--_1vcp0mh": (0, $7sObp.default)(__cmplp.width, "px")
            },
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_2rkon7od _kqswh2mm",
                (__cmplp.hasCoverPicture || __cmplp.isUploadingPicture) && __cmplp.smartSpaceOverviewHeight ? "_4t3ihojm" : (__cmplp.hasCoverPicture || __cmplp.isUploadingPicture) && __cmplp.isFixedWidthImageOption ? "_4t3i2pqz" : (__cmplp.hasCoverPicture || __cmplp.isUploadingPicture) && !__cmplp.isFixedWidthImageOption ? "_4t3i6w0c" : __cmplp.hasCoverPicture || __cmplp.isUploadingPicture ? "_4t3ifmv9" : "_4t3iidpf",
                (__cmplp.hasCoverPicture || __cmplp.isUploadingPicture) && __cmplp.isFixedWidthImageOption ? "_1bsb1c3h" : (__cmplp.hasCoverPicture || __cmplp.isUploadingPicture) && !__cmplp.isFixedWidthImageOption ? "_1bsb1osq" : (__cmplp.hasCoverPicture || __cmplp.isUploadingPicture) && __cmplp.width ? "_1bsb1efm" : "_1bsb1osq",
                !__cmplp.isReadOnly ? "_80omtlke" : "_80om1wug",
                __cmplp.isSmartSpaceOverview ? "_otyrze3t" : "_otyru2gc",
                __cmplp.isSmartSpaceOverview ? "_19pkze3t" : __cmplp.hasCoverPicture || __cmplp.isUploadingPicture ? "_19pk12x7" : "_19pkze3t",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});


const $4d3478acd5148f8b$export$7291ee1cb3635b5b = (props)=>{
    const $ = (0, $frIzR.c)(4);
    if ((0, $6mKj3.expValEquals)("confluence_page_cover_picture_css_migration", "isEnabled", true)) {
        let t0;
        if ($[0] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $27bd5511d1f80242$export$67a89e1eb110a1d7), props);
            $[0] = props;
            $[1] = t0;
        } else t0 = $[1];
        return t0;
    }
    let t0;
    if ($[2] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ae649144a67a3966$export$825ca283ddb318c2), props);
        $[2] = props;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
};


const $e4cacfdae9b2fb53$var$i18n = (0, $aXWIB.defineMessages)({
    errorFlagTitle: {
        id: "page-cover-picture.error.flag.title",
        defaultMessage: "We can\u2019t upload your header image"
    },
    errorFlagDescription: {
        id: "page-cover-picture.error.flag.description",
        defaultMessage: "Refresh and try again."
    },
    aiGenerationErrorFlagTitle: {
        id: "page-cover-picture.ai-generation.error.flag.title",
        defaultMessage: "We couldn't generate your header image"
    },
    aiGenerationErrorFlagDescription: {
        id: "page-cover-picture.ai-generation.error.flag.description",
        defaultMessage: "Try again or choose a different image."
    },
    aiGenerationErrorFlagDescriptionWithReason: {
        id: "page-cover-picture.ai-generation.error.flag.description-with-reason",
        defaultMessage: "{errorReason}. Try again or choose a different image."
    }
});
const $e4cacfdae9b2fb53$var$EditorPageCoverPictureComponent = /*#__PURE__*/ (0, $42omo.memo)(({ contentId: contentId, isPublishingContent: isPublishingContent, contentType: contentType, userOffline: userOffline, hasCoverPicture: hasCoverPicture, contentPropertyKey: contentPropertyKey, isSmartSpaceOverview: isSmartSpaceOverview, coverPictureState: coverPictureState, isUnpublishedDraft: isUnpublishedDraft, flags: flags, floatingToolbarButtonStyle: floatingToolbarButtonStyle, width: width, dynamicCoverImageHeight: dynamicCoverImageHeight, isReadOnly: isReadOnly, spaceKey: spaceKey, isFixedWidthImageOption: isFixedWidthImageOption, aiHeaderImageStatus: aiHeaderImageStatus, aiHeaderImageFileId: aiHeaderImageFileId, aiHeaderImageError: aiHeaderImageError, generateAIHeaderImage: generateAIHeaderImage, setAIHeaderImageStatus: setAIHeaderImageStatus, isSmartCreate: isSmartCreate })=>{
    const [isMediaBrowserOpen, setIsMediaBrowserOpen] = (0, $42omo.useState)(false);
    const { isExternalShareRequest: isExternalShare } = (0, $42omo.useContext)((0, $gXrHX.ExternalShareContext));
    const [isUploadingPicture, setIsUploadingPicture] = (0, $42omo.useState)(false);
    const [regenerationCount, setRegenerationCount] = (0, $42omo.useState)(0);
    // mediaConfig does not use onUploadRejection when in read only (RendererMediaProvider), but does need it otherwise (EditorMediaProvider).
    const [mediaConfig, setMediaConfig] = (0, $42omo.useState)(null);
    // Using ref since onHandleUploadEnd event uses previous cover picture information and upload will fail
    // since the information is from the past render
    const coverPicture = (0, $42omo.useRef)({
        draft: null
    });
    // need this force update since we are using useRef for the cover picture and therefore won't update the image automatically on change
    const [, forceUpdate] = (0, $42omo.useState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    // need this state since we want to show reposition option right after we upload a photo
    const [shouldShowReposition, setShouldShowReposition] = (0, $42omo.useState)(false);
    // AI Image Acceptance Flow state
    const [isRetryingAIImage, setIsRetryingAIImage] = (0, $42omo.useState)(false);
    // Track previous status to detect transition from LOADING_WITH_ACCEPTANCE_FLOW
    const prevAIHeaderImageStatusRef = (0, $42omo.useRef)(undefined);
    // Track previous status to detect transition INTO ERROR state (for showing error flag)
    const prevStatusForErrorFlagRef = (0, $42omo.useRef)(aiHeaderImageStatus ?? null);
    const ssrConfig = (0, $iP9x4.useMediaSSRModeAndAuthConfig)({
        contentId: contentId,
        isExternalShare: isExternalShare
    });
    const isServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)(true);
    const hasSSRConfigInSSRModeOrHydration = (isServerPlaceholder || window.__SSR_RENDERED__) && ssrConfig;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const intl = (0, $aXWIB.useIntl)();
    const smartSpaceOverviewHeight = isSmartSpaceOverview ? (0, $75Ax4.SMART_SPACE_OVERVIEW_FIXED_HEIGHT_FULL_WIDTH) : undefined;
    const analyticsSource = isSmartSpaceOverview ? 'smartSpaceOverview' : 'editorPageCoverPicture';
    const { updateContentProperty: updateContentProperty } = (0, $5kqgA.useUpdateContentProperty)({
        contentId: contentId,
        contentType: contentType || 'page',
        options: {
            refetchQueries: ()=>[
                    {
                        query: (0, $lC6Qd.default),
                        variables: {
                            contentId: contentId,
                            status: [
                                'draft'
                            ],
                            draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                        }
                    }
                ]
        }
    });
    const { data: data, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $lC6Qd.default), {
        context: {
            single: true
        },
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
        },
        __callerPackage__: "@confluence/page-cover-picture"
    });
    const updateCoverPicture = (0, $42omo.useCallback)(()=>{
        const properties = data?.content?.nodes?.[0]?.properties?.nodes || [];
        const draft = properties.find((p)=>p?.key === (0, $bKd7w.CoverPictureIdPropertyKey).DRAFT);
        const published = properties.find((p_0)=>p_0?.key === (0, $bKd7w.CoverPictureIdPropertyKey).PUBLISHED);
        // Smart Space Overview: when mutating PUBLISHED (no draft), display from published
        const propertyToUse = contentPropertyKey === (0, $bKd7w.CoverPictureIdPropertyKey).PUBLISHED ? published : draft;
        coverPicture.current = {
            draft: (0, $3WPGR.propertyToId)(propertyToUse)
        };
    }, [
        data,
        contentPropertyKey
    ]);
    const coverPictureData = (0, $3WPGR.getRendererCoverPictureInfo)(data, isLivePage);
    const coverPictureDataPosition = coverPictureData?.coverPicture?.published?.value?.position;
    const coverPictureDataId = coverPictureData?.coverPicture?.published?.value?.id;
    // Need this since the isUnsplash prop isn't getting the up to date values
    // Check if the cover picture is from Unsplash or Atlassian hosted CDN (dam-cdn or wac-cdn)
    const coverPictureId = coverPicture.current?.draft?.value?.id;
    // Setting this to null so that createLiveDocHeaderImageAnalyticsEvent is not fired until
    // isAllowedExternalCoverPicture is set to either true/false
    const isAllowedExternalCoverPicture = coverPictureId === undefined ? null : (0, $3WPGR.isAllowedExternalCoverPictureUrl)(coverPictureId);
    const isGeneratingHeaderImage = aiHeaderImageStatus === 'LOADING' || aiHeaderImageStatus === 'LOADING_WITH_ACCEPTANCE_FLOW';
    const [mutateCoverPictureWidth] = (0, $308Wd.useMutationInterop)((0, $50da084713014cf6$export$2e2bcd8739ae039), {
        onError: (error)=>{
            if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).MIGRATIONS_TOOLING
            });
        },
        __callerPackage__: "@confluence/page-cover-picture"
    });
    const onCoverPictureUpdatedSubscriptionData = (0, $42omo.useCallback)(async (_, response)=>{
        try {
            await refetch();
            const { coverPictureUpdated: coverPictureUpdated } = response || {};
            const value = JSON.parse(coverPictureUpdated?.value);
            const version = coverPictureUpdated?.version;
            coverPicture.current['draft'] = {
                value: value,
                version: version
            };
            coverPictureState.setHasCoverPicture(true);
            setIsUploadingPicture(false);
            coverPictureState.setIsUploadingPicture(false);
            coverPictureState.setCoverPictureId(value.id);
            forceUpdate(Math.random());
        } catch (error_0) {
            (0, $5ZqQS.getMonitoringClient)().submitError(error_0, {
                attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
            });
            (0, $7Sm4c.markErrorAsHandled)(error_0);
        }
    }, [
        refetch,
        coverPictureState
    ]);
    const onCoverPictureWidthUpdatedSubscription = (0, $42omo.useCallback)((__0, response_0)=>{
        const { coverPictureWidthUpdated: coverPictureWidthUpdated } = response_0 || {};
        const value_0 = coverPictureWidthUpdated?.coverPictureWidth;
        coverPictureState.toggleCoverPictureWidthButton(value_0);
        forceUpdate(Math.random());
    }, [
        coverPictureState
    ]);
    const onCoverPictureDeletedSubscription = (0, $42omo.useCallback)(async ()=>{
        try {
            await refetch();
            coverPicture.current['draft'] = null;
            coverPictureState.setHasCoverPicture(false);
            coverPictureState.setCoverPictureId(null);
            coverPictureState.setIsModalOpen(false);
            coverPictureState.setIsAddHeaderImageButtonFocused(false);
            forceUpdate(Math.random());
        } catch (error_1) {
            (0, $5ZqQS.getMonitoringClient)().submitError(error_1, {
                attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
            });
            (0, $7Sm4c.markErrorAsHandled)(error_1);
        }
    }, [
        refetch,
        coverPictureState
    ]);
    // Smart Space Overview: subscriptions don't fire, so refetch after mutations
    const refetchAfterMutation = (0, $42omo.useCallback)(async ()=>{
        try {
            await refetch();
            forceUpdate(Math.random());
        } catch (error_2) {
            (0, $5ZqQS.getMonitoringClient)().submitError(error_2, {
                attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
            });
            (0, $7Sm4c.markErrorAsHandled)(error_2);
        }
    }, [
        refetch
    ]);
    const subscriptionResourceType = contentType || 'page';
    (0, $i9VoI.useSubscriptionEvent)({
        subscriberId: 'EditingCoverPictureSubscription',
        contentId: contentId,
        delta: 'coverPictureUpdated',
        contentType: subscriptionResourceType,
        onDataReceived: onCoverPictureUpdatedSubscriptionData
    });
    (0, $i9VoI.useSubscriptionEvent)({
        subscriberId: 'EditorCoverPictureDeletedSubscription',
        contentId: contentId,
        delta: 'coverPictureDeleted',
        contentType: subscriptionResourceType,
        onDataReceived: onCoverPictureDeletedSubscription
    });
    (0, $i9VoI.useSubscriptionEvent)({
        subscriberId: 'EditorCoverPictureWidthUpdatedSubscription',
        contentId: contentId,
        delta: 'coverPictureWidthUpdated',
        contentType: subscriptionResourceType,
        onDataReceived: onCoverPictureWidthUpdatedSubscription
    });
    const propertyKeyForMutations = contentPropertyKey ?? (0, $bKd7w.CoverPictureIdPropertyKey).DRAFT;
    // Check for existing cover picture
    (0, $42omo.useEffect)(()=>{
        if ((0, $6mKj3.expValEquals)('platform_editor_editor_ssr_streaming', 'isEnabled', true)) updateCoverPicture();
        else {
            const properties_0 = data?.content?.nodes?.[0]?.properties?.nodes || [];
            const draft_0 = properties_0.find((p_1)=>p_1?.key === (0, $bKd7w.CoverPictureIdPropertyKey).DRAFT);
            const published_0 = properties_0.find((p_2)=>p_2?.key === (0, $bKd7w.CoverPictureIdPropertyKey).PUBLISHED);
            // Smart Space Overview: when mutating PUBLISHED (no draft), display from published
            const propertyToUse_0 = contentPropertyKey === (0, $bKd7w.CoverPictureIdPropertyKey).PUBLISHED ? published_0 : draft_0;
            coverPicture.current = {
                draft: (0, $3WPGR.propertyToId)(propertyToUse_0)
            };
        }
        forceUpdate(Math.random());
    }, [
        data,
        contentPropertyKey,
        updateCoverPicture
    ]);
    // Setup media config
    (0, $42omo.useEffect)(()=>{
        const showAttachmentLimitReachedFlag = (rejectionData)=>{
            if (flags && rejectionData) flags.showErrorFlag((0, $2vVvv.getAttachmentSizeLimitErrorFlag)(rejectionData, intl)).then(()=>{
                setIsUploadingPicture(false);
                coverPictureState.setIsUploadingPicture(false);
                experienceTracker.abort({
                    name: (0, $irVI7.COVER_PICTURE_MEDIA_UPLOAD_EXPERIENCE),
                    reason: 'Cover picture media upload too large'
                });
                createAnalyticsEvent({
                    type: 'sendScreenEvent',
                    data: {
                        name: 'pageCoverPictureAttachmentTooLargeFlag'
                    }
                }).fire();
            });
            return !!rejectionData;
        };
        // If read only, use renderer media provider, as we only need the auth provider from rendererMediaProvider, and user without edit perms (read only) doesn't have access to editorMediaProvider APIs
        // If not read only, use editor media provider
        const createMediaConfig = async ()=>{
            if (isReadOnly) {
                const { viewMediaClientConfig: viewMediaClientConfig } = await (0, $4IoVL.createRendererMediaProvider)({
                    contentId: contentId,
                    isExternalShare: false
                });
                if (!viewMediaClientConfig) return null;
                setMediaConfig({
                    collection: `contentId-${contentId}`,
                    authProvider: viewMediaClientConfig.authProvider
                });
            } else {
                const { uploadParams: uploadParams, uploadMediaClientConfig: uploadMediaClientConfig } = await (0, $4IoVL.createEditorMediaProvider)({
                    contentId: contentId,
                    contentType: 'page',
                    isExternalShare: isExternalShare,
                    onUploadRejection: flags ? showAttachmentLimitReachedFlag : undefined
                });
                if (uploadMediaClientConfig == undefined) return null;
                setMediaConfig({
                    collection: uploadParams?.collection,
                    authProvider: uploadMediaClientConfig.authProvider,
                    onUploadRejection: uploadParams?.onUploadRejection,
                    useSha256ForUploads: uploadMediaClientConfig?.useSha256ForUploads
                });
            }
        };
        createMediaConfig();
    }, [
        contentId,
        isExternalShare,
        flags,
        intl,
        coverPictureState,
        createAnalyticsEvent,
        experienceTracker,
        isReadOnly
    ]);
    // handling user publishes - we only need to worry about firing the analytic event as backend will take care of the
    // published cover picture content property mutation due to scheduled publishes
    (0, $42omo.useEffect)(()=>{
        // fire analytic if we're publishing a page with a cover image
        if (isPublishingContent && !!coverPicture.current?.draft?.value.id) {
            if (isUnpublishedDraft) createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'createdWithHeaderImage',
                    actionSubject: 'page',
                    objectId: contentId,
                    source: analyticsSource
                }
            }).fire();
            else createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'updatedWithHeaderImage',
                    actionSubject: 'page',
                    objectId: contentId,
                    source: analyticsSource
                }
            }).fire();
        }
    }, [
        contentId,
        isPublishingContent,
        isUnpublishedDraft,
        createAnalyticsEvent,
        analyticsSource
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isPublishingContent && hasCoverPicture) coverPictureState.setShouldShowReposition(false);
    }, [
        hasCoverPicture,
        isPublishingContent,
        coverPictureState
    ]);
    const showErrorFlag = ()=>{
        flags.showFlag({
            type: 'error',
            title: formatMessage($e4cacfdae9b2fb53$var$i18n.errorFlagTitle),
            description: formatMessage($e4cacfdae9b2fb53$var$i18n.errorFlagDescription),
            messageType: 'transactional',
            messageId: 'page-cover-picture-error-flag'
        });
        setIsUploadingPicture(false);
        coverPictureState.setIsUploadingPicture(false);
        experienceTracker.stopOnError({
            name: (0, $irVI7.COVER_PICTURE_MEDIA_UPLOAD_EXPERIENCE),
            error: new Error('Error with cover picture media upload')
        });
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'pageCoverPictureErrorFlag'
            }
        }).fire();
    };
    const showAIGenerationErrorFlag = (0, $42omo.useCallback)((errorReason)=>{
        // Use the API error reason if available, otherwise fall back to generic message
        const description = errorReason ? formatMessage($e4cacfdae9b2fb53$var$i18n.aiGenerationErrorFlagDescriptionWithReason, {
            errorReason: errorReason
        }) : formatMessage($e4cacfdae9b2fb53$var$i18n.aiGenerationErrorFlagDescription);
        flags.showFlag({
            type: 'error',
            title: formatMessage($e4cacfdae9b2fb53$var$i18n.aiGenerationErrorFlagTitle),
            description: description,
            messageType: 'transactional',
            messageId: 'page-cover-picture-ai-generation-error-flag'
        });
        // Clear loading states
        setIsUploadingPicture(false);
        coverPictureState.setIsUploadingPicture(false);
        setIsRetryingAIImage(false);
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'pageCoverPictureAIGenerationErrorFlag',
                attributes: {
                    errorReason: errorReason || 'unknown'
                }
            }
        }).fire();
    }, [
        flags,
        formatMessage,
        coverPictureState,
        createAnalyticsEvent
    ]);
    const handleUploadStart = ()=>{
        setIsUploadingPicture(true);
        coverPictureState.setIsUploadingPicture(true);
        coverPictureState.setIsChangingPicture(false);
        experienceTracker.start({
            name: (0, $irVI7.COVER_PICTURE_MEDIA_UPLOAD_EXPERIENCE)
        });
    };
    const handleUploadEnd = (event)=>{
        const fileType = event.file.type;
        const id = event?.file?.id;
        if (!fileType.includes('image')) showErrorFlag();
        else if (id) {
            const currentAIFCAutoImage = coverPictureState.state.isCurrentAIFCAutoImage;
            // must JSON stringify propertyValue object since mutation expects a string for this parameter
            const propertyValue = JSON.stringify({
                id: id,
                position: (0, $75Ax4.DEFAULT_POSITION_VALUE)
            });
            const updatePromise = updateContentProperty({
                propertyKey: propertyKeyForMutations,
                propertyValue: propertyValue,
                isDelete: false,
                hasExistingProperty: hasCoverPicture
            });
            if (isSmartSpaceOverview && updatePromise) updatePromise.then(()=>{
                refetchAfterMutation();
                setIsUploadingPicture(false);
                coverPictureState.setIsUploadingPicture(false);
            });
            else if (updatePromise && (0, $9wGTI.fg)('confluence_cover_pic_optimistic_update_fallback')) updatePromise.then(async ()=>{
                try {
                    await refetch();
                    coverPicture.current['draft'] = {
                        value: {
                            id: id,
                            position: (0, $75Ax4.DEFAULT_POSITION_VALUE)
                        },
                        version: (coverPicture.current?.draft?.version || 0) + 1
                    };
                    coverPictureState.setHasCoverPicture(true);
                    setIsUploadingPicture(false);
                    coverPictureState.setIsUploadingPicture(false);
                    coverPictureState.setCoverPictureId(id);
                    forceUpdate(Math.random());
                } catch (error_3) {
                    (0, $5ZqQS.getMonitoringClient)().submitError(error_3, {
                        attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
                    });
                    (0, $7Sm4c.markErrorAsHandled)(error_3);
                }
            });
            setShouldShowReposition(true);
            coverPictureState.setShouldShowReposition(true);
            coverPictureState.setIsCurrentAIFCAutoImage(false);
            experienceTracker.succeed({
                name: (0, $irVI7.COVER_PICTURE_MEDIA_UPLOAD_EXPERIENCE)
            });
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'added',
                    actionSubject: 'image',
                    actionSubjectId: 'headerImageAdded',
                    source: analyticsSource,
                    attributes: {
                        imageSource: 'uploaded',
                        imageId: id,
                        inputMethod: 'header',
                        isLivePage: isLivePage,
                        isAIGenerationEnabled: (0, $6mKj3.isExperimentEnabled)('cc_page_experiences_ai_header_image_generation'),
                        isAIFCAutoGeneratedImageEnabled: (0, $6mKj3.isExperimentEnabled)('cc_page_experiences_aifc_auto_generated_header_img'),
                        isAIFCAutoGeneratedImage: false
                    }
                }
            }).fire();
            if (currentAIFCAutoImage) createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'replaced',
                    actionSubject: 'image',
                    actionSubjectId: 'autoGeneratedAIFCImageReplaced',
                    source: analyticsSource,
                    attributes: {
                        imageSource: 'uploaded',
                        inputMethod: 'header',
                        isAIGenerationEnabled: (0, $6mKj3.isExperimentEnabled)('cc_page_experiences_ai_header_image_generation')
                    }
                }
            }).fire();
        } else showErrorFlag();
    };
    const handleUnsplashUpload = (0, $42omo.useCallback)((photoURL)=>{
        const currentAIFCAutoImage_0 = coverPictureState.state.isCurrentAIFCAutoImage;
        setIsUploadingPicture(true);
        coverPictureState.setIsUploadingPicture(true);
        const propertyValue_0 = JSON.stringify({
            id: photoURL,
            position: (0, $75Ax4.DEFAULT_POSITION_VALUE)
        });
        const updatePromise_0 = updateContentProperty({
            propertyKey: propertyKeyForMutations,
            propertyValue: propertyValue_0,
            isDelete: false,
            hasExistingProperty: hasCoverPicture
        });
        if (isSmartSpaceOverview && updatePromise_0) updatePromise_0.then(()=>{
            refetchAfterMutation();
            setIsUploadingPicture(false);
            coverPictureState.setIsUploadingPicture(false);
        });
        else if (updatePromise_0 && (0, $9wGTI.fg)('confluence_cover_pic_optimistic_update_fallback')) updatePromise_0.then(async ()=>{
            try {
                await refetch();
                coverPicture.current['draft'] = {
                    value: {
                        id: photoURL,
                        position: (0, $75Ax4.DEFAULT_POSITION_VALUE)
                    },
                    version: (coverPicture.current?.draft?.version || 0) + 1
                };
                coverPictureState.setHasCoverPicture(true);
                setIsUploadingPicture(false);
                coverPictureState.setIsUploadingPicture(false);
                coverPictureState.setCoverPictureId(photoURL);
                forceUpdate(Math.random());
            } catch (error_4) {
                (0, $5ZqQS.getMonitoringClient)().submitError(error_4, {
                    attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
                });
                (0, $7Sm4c.markErrorAsHandled)(error_4);
            }
        });
        setShouldShowReposition(true);
        coverPictureState.setShouldShowReposition(true);
        coverPictureState.setIsCurrentAIFCAutoImage(false);
        experienceTracker.succeed({
            name: (0, $irVI7.COVER_PICTURE_UNSPLASH_UPLOAD_EXPERIENCE)
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'added',
                actionSubject: 'image',
                actionSubjectId: 'headerImageAdded',
                source: analyticsSource,
                attributes: {
                    imageSource: 'unsplash',
                    imageId: photoURL,
                    inputMethod: 'header',
                    isLivePage: isLivePage,
                    isAIGenerationEnabled: (0, $6mKj3.isExperimentEnabled)('cc_page_experiences_ai_header_image_generation'),
                    isAIFCAutoGeneratedImageEnabled: (0, $6mKj3.isExperimentEnabled)('cc_page_experiences_aifc_auto_generated_header_img'),
                    isAIFCAutoGeneratedImage: false
                }
            }
        }).fire();
        if (currentAIFCAutoImage_0) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'replaced',
                actionSubject: 'image',
                actionSubjectId: 'autoGeneratedAIFCImageReplaced',
                source: analyticsSource,
                attributes: {
                    imageSource: 'unsplash',
                    inputMethod: 'header',
                    isAIGenerationEnabled: (0, $6mKj3.isExperimentEnabled)('cc_page_experiences_ai_header_image_generation')
                }
            }
        }).fire();
    }, [
        coverPictureState,
        createAnalyticsEvent,
        experienceTracker,
        isLivePage,
        updateContentProperty,
        hasCoverPicture,
        propertyKeyForMutations,
        isSmartSpaceOverview,
        refetchAfterMutation,
        refetch,
        analyticsSource
    ]);
    const handleAIGeneratedUpload = (0, $42omo.useCallback)((mediaFileId, skipStatusUpdate = false, isAIFCAutoGeneratedImage = false)=>{
        const propertyValue_1 = JSON.stringify({
            id: mediaFileId,
            position: (0, $75Ax4.DEFAULT_POSITION_VALUE)
        });
        const updatePromise_1 = updateContentProperty({
            propertyKey: propertyKeyForMutations,
            propertyValue: propertyValue_1,
            isDelete: false,
            hasExistingProperty: hasCoverPicture
        });
        if (isSmartSpaceOverview && updatePromise_1) updatePromise_1.then(()=>{
            refetchAfterMutation();
        });
        else if (updatePromise_1 && (0, $9wGTI.fg)('confluence_cover_pic_optimistic_update_fallback')) updatePromise_1.then(async ()=>{
            try {
                await refetch();
                coverPicture.current['draft'] = {
                    value: {
                        id: mediaFileId,
                        position: (0, $75Ax4.DEFAULT_POSITION_VALUE)
                    },
                    version: (coverPicture.current?.draft?.version || 0) + 1
                };
                coverPictureState.setHasCoverPicture(true);
                coverPictureState.setCoverPictureId(mediaFileId);
                forceUpdate(Math.random());
            } catch (error_5) {
                (0, $5ZqQS.getMonitoringClient)().submitError(error_5, {
                    attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
                });
                (0, $7Sm4c.markErrorAsHandled)(error_5);
            }
        });
        // Don't set SUCCESSFULLY_SET if we're showing acceptance flow
        // The status will be set when user accepts the image
        if (!skipStatusUpdate) setAIHeaderImageStatus?.('SUCCESSFULLY_SET');
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'added',
                actionSubject: 'image',
                actionSubjectId: 'headerImageAdded',
                source: analyticsSource,
                attributes: {
                    imageSource: 'aiGenerated',
                    imageId: mediaFileId,
                    inputMethod: 'header',
                    isLivePage: isLivePage,
                    isAIGenerationEnabled: (0, $6mKj3.isExperimentEnabled)('cc_page_experiences_ai_header_image_generation'),
                    isAIFCAutoGeneratedImageEnabled: (0, $6mKj3.isExperimentEnabled)('cc_page_experiences_aifc_auto_generated_header_img'),
                    isAIFCAutoGeneratedImage: isAIFCAutoGeneratedImage
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isLivePage,
        setAIHeaderImageStatus,
        updateContentProperty,
        hasCoverPicture,
        propertyKeyForMutations,
        isSmartSpaceOverview,
        refetchAfterMutation,
        refetch,
        coverPictureState,
        analyticsSource
    ]);
    const updateCoverPictureState = (0, $42omo.useCallback)(async ()=>{
        await coverPictureState.setHasCoverPicture(true);
    }, [
        coverPictureState
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!(0, $6mKj3.isExperimentEnabled)('cc_page_experiences_ai_header_image_generation') && !(0, $6mKj3.isExperimentEnabled)('cc_page_experiences_aifc_auto_generated_header_img')) return;
        // Track status transitions to detect when loading completes
        const prevStatus = prevAIHeaderImageStatusRef.current;
        const wasLoadingWithAcceptance = prevStatus === 'LOADING_WITH_ACCEPTANCE_FLOW';
        prevAIHeaderImageStatusRef.current = aiHeaderImageStatus;
        if (isGeneratingHeaderImage) coverPictureState.setIsUploadingPicture(true);
        else {
            coverPictureState.setIsUploadingPicture(false);
            if (aiHeaderImageFileId && aiHeaderImageStatus !== 'SUCCESSFULLY_SET') {
                // We've just observed `aiHeaderImageFileId` transition from
                // null/undefined to a real media file id, which means the AI
                // generation request has succeeded. Immediately clear the
                // locally-cached previous cover picture id so the old header
                // image stops rendering. Without this, there is a brief flash
                // of the previous image between the loading spinner being
                // removed and the new mediaFileId being committed to the
                // cover picture content property (the property update below
                // is async and only takes effect once the GraphQL
                // subscription fires).
                //
                // Crucially this only runs in the success branch — if
                // generation failed, `aiHeaderImageFileId` stays falsy, this
                // code does not run, and the previous header image remains
                // visible to the user.
                coverPicture.current['draft'] = null;
                // Check if we should show acceptance flow:
                // Either from the stored params (when wrapped function is called) or from status transition
                const lastParams = coverPictureState.state.lastAIGenerationParams;
                const shouldShowAcceptance = lastParams?.showAcceptanceFlow || wasLoadingWithAcceptance;
                const isAIFCAutoGenerated = !shouldShowAcceptance && !!isSmartCreate;
                coverPictureState.setIsCurrentAIFCAutoImage(isAIFCAutoGenerated);
                try {
                    // If showing acceptance flow, don't set status to SUCCESSFULLY_SET yet
                    // User needs to accept first
                    // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates
                    handleAIGeneratedUpload(aiHeaderImageFileId, shouldShowAcceptance, isAIFCAutoGenerated);
                } finally{
                    updateCoverPictureState();
                }
                // Show the acceptance flow with repositioning when image is ready
                if (shouldShowAcceptance) {
                    // Clear uploading state to allow acceptance UI to show
                    // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates
                    setIsUploadingPicture(false);
                    coverPictureState.setShouldShowAIImageAcceptanceFlow(true);
                    // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates
                    setIsRetryingAIImage(false);
                }
            }
        }
    }, [
        isGeneratingHeaderImage,
        coverPictureState,
        aiHeaderImageFileId,
        handleAIGeneratedUpload,
        updateCoverPictureState,
        aiHeaderImageStatus,
        isSmartCreate
    ]);
    // Watch for AI generation error status and show error flag to user
    // Only show flag on TRANSITION into ERROR state, not on re-renders while in ERROR state
    (0, $42omo.useEffect)(()=>{
        const prevStatus_0 = prevStatusForErrorFlagRef.current;
        const currentStatus = aiHeaderImageStatus;
        // Only show error flag when TRANSITIONING into ERROR state
        // This prevents duplicate flags from re-renders while already in ERROR state
        const isTransitioningToError = prevStatus_0 !== 'ERROR' && currentStatus === 'ERROR';
        // Don't show error flags for AIFC auto-generated images (where the image is
        // generated automatically from the title without user interaction).
        // The auto flow uses 'LOADING' status (no acceptance flow), while user-initiated
        // generation uses 'LOADING_WITH_ACCEPTANCE_FLOW'. We detect auto flow by checking
        // if the previous status was 'LOADING' (not 'LOADING_WITH_ACCEPTANCE_FLOW').
        const wasAIFCAutoGenerated = prevStatus_0 === 'LOADING';
        if (isTransitioningToError && !wasAIFCAutoGenerated) // Due to a false positive
        // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates
        showAIGenerationErrorFlag(aiHeaderImageError);
        // Update the ref for next render
        prevStatusForErrorFlagRef.current = currentStatus ?? null;
    }, [
        aiHeaderImageStatus,
        aiHeaderImageError,
        showAIGenerationErrorFlag
    ]);
    // Handler for accepting AI generated image (from AIImageAcceptanceRepositioner)
    const onAcceptAIGeneratedImage = (0, $42omo.useCallback)(()=>{
        coverPictureState.setShouldShowAIImageAcceptanceFlow(false);
        setAIHeaderImageStatus?.('SUCCESSFULLY_SET');
        coverPictureState.setLastAIGenerationParams(null);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'accepted',
                actionSubject: 'aiGeneratedImage',
                actionSubjectId: 'aiGeneratedHeaderImage',
                source: analyticsSource,
                attributes: {
                    regenerationCount: regenerationCount
                }
            }
        }).fire();
    }, [
        setAIHeaderImageStatus,
        regenerationCount,
        createAnalyticsEvent,
        coverPictureState,
        analyticsSource
    ]);
    // Handler for retrying AI image generation (from AIImageAcceptanceRepositioner)
    const onRetryAIGeneratedImage = (0, $42omo.useCallback)(async ()=>{
        const lastParams_0 = coverPictureState.state.lastAIGenerationParams;
        if (!generateAIHeaderImage) {
            // eslint-disable-next-line no-console
            console.warn('[AI Header Image] generateAIHeaderImage is not available');
            return;
        }
        if (!lastParams_0) {
            // This should never happen - if the user clicked retry, there should be stored params
            // eslint-disable-next-line no-console
            console.error('[AI Header Image] Cannot retry: no stored generation parameters found');
            return;
        }
        setIsRetryingAIImage(true);
        setRegenerationCount((prev)=>prev + 1);
        await generateAIHeaderImage({
            ...lastParams_0,
            showAcceptanceFlow: true
        });
    }, [
        generateAIHeaderImage,
        coverPictureState.state.lastAIGenerationParams
    ]);
    // Wrapped generateAIHeaderImage that stores params for retry functionality
    const wrappedGenerateAIHeaderImage = (0, $42omo.useCallback)(async (props)=>{
        if (generateAIHeaderImage) {
            // Store params in container state so we can retry with the same params
            // Using container state ensures params survive component re-mounts
            coverPictureState.setLastAIGenerationParams(props);
            return generateAIHeaderImage(props);
        }
        return undefined;
    }, [
        generateAIHeaderImage,
        coverPictureState
    ]);
    const onRemoveImage = (0, $42omo.useCallback)(async ()=>{
        coverPictureState.setIsRemovingPicture(true);
        coverPictureState.setIsAddHeaderImageButtonFocused(false);
        const updatePromise_2 = updateContentProperty({
            propertyKey: propertyKeyForMutations,
            isDelete: true,
            hasExistingProperty: hasCoverPicture
        });
        if (isSmartSpaceOverview && updatePromise_2) updatePromise_2.then(async ()=>{
            if (typeof refetch === 'function') await refetch();
            coverPicture.current['draft'] = null;
            coverPictureState.setHasCoverPicture(false);
            coverPictureState.setCoverPictureId(null);
            coverPictureState.setIsModalOpen(false);
            forceUpdate(Math.random());
        });
        else if (updatePromise_2 && (0, $9wGTI.fg)('confluence_cover_pic_optimistic_update_fallback')) updatePromise_2.then(async ()=>{
            try {
                if (typeof refetch === 'function') await refetch();
                coverPicture.current['draft'] = null;
                coverPictureState.setHasCoverPicture(false);
                coverPictureState.setCoverPictureId(null);
                coverPictureState.setIsModalOpen(false);
                coverPictureState.setIsAddHeaderImageButtonFocused(false);
                forceUpdate(Math.random());
            } catch (error_6) {
                (0, $5ZqQS.getMonitoringClient)().submitError(error_6, {
                    attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
                });
                (0, $7Sm4c.markErrorAsHandled)(error_6);
            }
        });
        coverPictureState.setIsChangingPicture(false);
        coverPictureState.setIsModalOpen(false);
        // Clear AI image acceptance flow state when image is removed/discarded
        if (coverPictureState.state.shouldShowAIImageAcceptanceFlow) {
            coverPictureState.setShouldShowAIImageAcceptanceFlow(false);
            coverPictureState.setLastAIGenerationParams(null);
            // Set to SUCCESSFULLY_SET
            setAIHeaderImageStatus?.('SUCCESSFULLY_SET');
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'discarded',
                    actionSubject: 'aiGeneratedImage',
                    actionSubjectId: 'aiGeneratedHeaderImage',
                    source: analyticsSource,
                    attributes: {
                        regenerationCount: regenerationCount
                    }
                }
            }).fire();
        }
        coverPictureState.setIsCurrentAIFCAutoImage(false);
        coverPictureState.setIsRemovingPicture(false);
        experienceTracker.succeed({
            name: (0, $irVI7.COVER_PICTURE_REMOVE_EXPERIENCE)
        });
    }, [
        coverPictureState,
        experienceTracker,
        createAnalyticsEvent,
        regenerationCount,
        updateContentProperty,
        hasCoverPicture,
        setAIHeaderImageStatus,
        propertyKeyForMutations,
        isSmartSpaceOverview,
        refetch,
        analyticsSource
    ]);
    const onImageWidthChange = (0, $42omo.useCallback)(async (coverPictureWidth)=>{
        if (coverPictureWidth !== coverPictureState.state.coverPictureWidth) {
            coverPictureState.toggleCoverPictureWidthButton(coverPictureWidth);
            //hack the input and outout have different capitalizations TT_TT
            // the mutation returns lowercase, the mutation expects uppercase
            await mutateCoverPictureWidth({
                variables: {
                    contentId: contentId,
                    // Casting to GraphQLCoverPictureWidth as structurally equivalent enums are not equal in TS
                    coverPictureWidth: coverPictureWidth.toUpperCase()
                }
            });
        }
    }, [
        contentId,
        mutateCoverPictureWidth,
        coverPictureState
    ]);
    const onSaveReposition = async (position)=>{
        // check that the position isn't the same as the current one
        if (position != coverPicture.current?.draft?.value.position) {
            const version_0 = String((coverPicture.current?.draft?.version || 0) + 1);
            const propertyValue_2 = JSON.stringify({
                id: coverPicture.current?.draft?.value.id,
                position: position
            });
            coverPicture.current.draft.value.position = position;
            coverPicture.current.draft.version = parseInt(version_0);
            const updatePromise_3 = updateContentProperty({
                propertyKey: propertyKeyForMutations,
                propertyValue: propertyValue_2,
                isDelete: false,
                hasExistingProperty: hasCoverPicture
            });
            if (isSmartSpaceOverview && updatePromise_3) updatePromise_3.then(()=>{
                refetchAfterMutation();
            });
        }
    };
    const openMediaBrowser = ()=>{
        setIsMediaBrowserOpen(true);
    };
    const closeMediaBrowser = ()=>{
        setIsMediaBrowserOpen(false);
    };
    const createLiveDocHeaderImageAnalyticsEvent = (0, $42omo.useCallback)((isUnsplashImage)=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'viewed',
                actionSubject: 'LiveDocHeaderImage',
                actionSubjectId: 'liveDocHeaderImage',
                source: 'liveDocHeaderImage',
                attributes: {
                    headerImageType: isUnsplashImage ? 'unsplash' : 'user-uploaded',
                    isAIGenerationEnabled: (0, $6mKj3.isExperimentEnabled)('cc_page_experiences_ai_header_image_generation'),
                    isAIFCAutoGeneratedImageEnabled: (0, $6mKj3.isExperimentEnabled)('cc_page_experiences_aifc_auto_generated_header_img')
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if (hasCoverPicture && isLivePage && isAllowedExternalCoverPicture != null) createLiveDocHeaderImageAnalyticsEvent(isAllowedExternalCoverPicture);
    }, [
        isAllowedExternalCoverPicture,
        isLivePage,
        hasCoverPicture,
        createLiveDocHeaderImageAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dA1Sn.TwoStageHydration), {
        name: "editor-page-cover-picture",
        // cc_editor_two_stage_hydration_removal - When cleaning up this experiment, also remove the related TwoStageHydration component
        enabled: !(0, $6mKj3.expValEquals)('cc_editor_two_stage_hydration_removal', 'editorCoverPicture', true),
        ssrPlaceholder: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), null, hasCoverPicture && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("style", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `
									@container editor-area (width < 760px) {
										.cover-picture-wrapper-dangerously-set-inner-html {
											height: ${smartSpaceOverviewHeight ?? 147}px
										}
									}
									@container editor-area (width >= 4071px) {
										.cover-picture-wrapper-dangerously-set-inner-html {
											height: ${smartSpaceOverviewHeight ?? 750}px
										}
									}
									`
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4d3478acd5148f8b$export$7291ee1cb3635b5b), {
        hasCoverPicture: hasCoverPicture,
        isUploadingPicture: isUploadingPicture,
        "data-testid": "cover-picture-wrapper",
        width: width,
        dynamicCoverImageHeight: dynamicCoverImageHeight,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: "cover-picture-wrapper-dangerously-set-inner-html",
        isFixedWidthImageOption: isFixedWidthImageOption,
        smartSpaceOverviewHeight: smartSpaceOverviewHeight,
        isSmartSpaceOverview: isSmartSpaceOverview,
        isReadOnly: isReadOnly
    }, hasCoverPicture && (mediaConfig || hasSSRConfigInSSRModeOrHydration) && (isAllowedExternalCoverPicture ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4dbf19c0ece58c9f$export$8e0ec3f3e7cffe52), {
        coverPicture: coverPicture,
        dynamicCoverImageHeight: dynamicCoverImageHeight,
        isFixedWidthImageOption: isFixedWidthImageOption,
        smartSpaceOverviewHeight: smartSpaceOverviewHeight,
        coverPictureDataPosition: coverPictureDataPosition,
        coverPictureDataId: coverPictureDataId,
        isRoundedCorners: isSmartSpaceOverview
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6daaa50e0e3ea99a$export$22e679d20747684f), {
        coverPicture: coverPicture,
        mediaConfig: mediaConfig,
        ssrConfig: ssrConfig,
        contentId: contentId,
        showErrorFlag: showErrorFlag,
        hasSSRConfigInSSRModeOrHydration: hasSSRConfigInSSRModeOrHydration,
        isFixedWidthImageOption: isFixedWidthImageOption,
        smartSpaceOverviewHeight: smartSpaceOverviewHeight,
        isAIGenerated: !!aiHeaderImageFileId,
        isRoundedCorners: isSmartSpaceOverview
    })), !isReadOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $689140bd887be349$export$4103f8c62b69a0b3), {
        hasCoverPicture: hasCoverPicture,
        openMediaBrowser: openMediaBrowser,
        onRemoveImage: onRemoveImage,
        userOffline: userOffline,
        isUploadingPicture: isUploadingPicture,
        handleUnsplashUpload: handleUnsplashUpload,
        setIsUploadingPicture: setIsUploadingPicture,
        initialPicturePosition: coverPicture.current.draft?.value.position,
        onSaveReposition: onSaveReposition,
        shouldShowReposition: shouldShowReposition,
        setShouldShowReposition: setShouldShowReposition,
        coverPictureState: coverPictureState,
        floatingToolbarButtonStyle: floatingToolbarButtonStyle,
        forceUpdate: forceUpdate,
        contentId: contentId,
        dynamicCoverImageHeight: dynamicCoverImageHeight,
        smartSpaceOverviewHeight: smartSpaceOverviewHeight,
        onImageWidthChange: isSmartSpaceOverview ? undefined : onImageWidthChange,
        isRoundedCorners: isSmartSpaceOverview,
        spaceKey: spaceKey,
        isFixedWidthImageOption: isFixedWidthImageOption,
        generateAIHeaderImage: generateAIHeaderImage ? wrappedGenerateAIHeaderImage : undefined,
        // AI Image Acceptance Flow props
        shouldShowAIImageAcceptanceFlow: coverPictureState.state.shouldShowAIImageAcceptanceFlow,
        onAcceptAIGeneratedImage: onAcceptAIGeneratedImage,
        onRetryAIGeneratedImage: onRetryAIGeneratedImage,
        isRetryingAIImage: isRetryingAIImage,
        analyticsSource: analyticsSource
    })), !isReadOnly && mediaConfig && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $10CSJ.BrowserLoader), {
        mediaClientConfig: {
            authProvider: mediaConfig?.authProvider,
            useSha256ForUploads: mediaConfig?.useSha256ForUploads
        },
        config: {
            multiple: false,
            fileExtensions: [
                '.jpg',
                '.jpeg',
                '.png',
                '.gif'
            ],
            uploadParams: {
                collection: mediaConfig.collection,
                onUploadRejection: mediaConfig?.onUploadRejection
            }
        },
        isOpen: isMediaBrowserOpen,
        onClose: closeMediaBrowser,
        onUploadsStart: handleUploadStart,
        onError: showErrorFlag,
        onEnd: handleUploadEnd
    })));
});
const $e4cacfdae9b2fb53$export$61fcba19b6a07b00 = (0, $7aRa9.withFlags)((0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
})($e4cacfdae9b2fb53$var$EditorPageCoverPictureComponent));
module.exports["EditorPageCoverPicture"] = $e4cacfdae9b2fb53$export$61fcba19b6a07b00;

});

parcelRegister("10CSJ", function(module, exports) {

var $42omo = parcelRequire("42omo");



class $330e3eb3197f64f9$export$3ce634ac4a869e2c extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    componentDidMount() {
        this.mounted = true;
        if (!this.state.Browser) Promise.all([
            (parcelRequire("1ON5X")),
            (parcelRequire("4ysKA"))
        ]).then(([mediaClient, browserModule])=>{
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $330e3eb3197f64f9$export$3ce634ac4a869e2c.Browser = mediaClient.withMediaClient(browserModule.Browser);
            if (this.mounted) this.setState({
                Browser: $330e3eb3197f64f9$export$3ce634ac4a869e2c.Browser
            });
        });
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        if (!this.state.Browser) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(this.state.Browser, this.props);
    }
    constructor(...args){
        super(...args);
        this.mounted = false;
        this.state = {
            Browser: $330e3eb3197f64f9$export$3ce634ac4a869e2c.Browser
        };
    }
}
$330e3eb3197f64f9$export$3ce634ac4a869e2c.displayName = 'AsyncBrowser';
$330e3eb3197f64f9$export$3ce634ac4a869e2c.Browser = void 0;
module.exports["BrowserLoader"] = $330e3eb3197f64f9$export$3ce634ac4a869e2c;

});

parcelRegister("1ON5X", function(module, exports) {

let $15308b37382bd456$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $15308b37382bd456$var$load("hRqzw"),
    $15308b37382bd456$var$load("7I05g"),
    $15308b37382bd456$var$load("8j9XC"),
    $15308b37382bd456$var$load("6aruy")
]).then(()=>parcelRequire('9VKkC'));

});

parcelRegister("4ysKA", function(module, exports) {

let $3510a3a429df29ec$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3510a3a429df29ec$var$load("8j9XC"),
    $3510a3a429df29ec$var$load("hRqzw"),
    $3510a3a429df29ec$var$load("f35QR"),
    $3510a3a429df29ec$var$load("eVYW1"),
    $3510a3a429df29ec$var$load("ls0Um"),
    $3510a3a429df29ec$var$load("020xd"),
    $3510a3a429df29ec$var$load("eTBsW"),
    $3510a3a429df29ec$var$load("bYxCZ"),
    $3510a3a429df29ec$var$load("6HBYC"),
    $3510a3a429df29ec$var$load("eDqo1"),
    $3510a3a429df29ec$var$load("lxiFd"),
    $3510a3a429df29ec$var$load("1oiJ6"),
    $3510a3a429df29ec$var$load("huUvS"),
    $3510a3a429df29ec$var$load("dT77m"),
    $3510a3a429df29ec$var$load("6vhrJ"),
    $3510a3a429df29ec$var$load("fxC6e"),
    $3510a3a429df29ec$var$load("hqblC")
]).then(()=>parcelRequire('4rZL5'));

});

parcelRegister("i9VoI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6UYek = parcelRequire("6UYek");

const $357775eda04c1a81$export$63ba9f3f1b368ae8 = ({ onDataReceived: onDataReceived, skip: skip = false, contentId: contentId, contentType: contentType, delta: delta, subscriberId: subscriberId })=>{
    const dispatch = (0, $6UYek.useSubscriptionsDispatchContext)();
    const { setContentId: setContentId, setContentType: setContentType, removeSubscriber: removeSubscriber, addSubscriber: addSubscriber } = dispatch || {};
    (0, $42omo.useEffect)(()=>{
        if (skip || !addSubscriber || !contentId || !contentType || !removeSubscriber) return;
        setContentId?.(contentId);
        setContentType?.(contentType);
        const uniqueSubscriberId = addSubscriber({
            delta: delta,
            subscriberId: subscriberId,
            onSubscriptionData: onDataReceived
        });
        return ()=>{
            removeSubscriber({
                delta: delta,
                subscriberId: uniqueSubscriberId
            });
        };
    }, [
        skip,
        dispatch,
        contentId,
        contentType,
        setContentId,
        setContentType,
        addSubscriber,
        removeSubscriber,
        subscriberId,
        delta,
        onDataReceived
    ]);
    return null;
};
module.exports["useSubscriptionEvent"] = $357775eda04c1a81$export$63ba9f3f1b368ae8;

});

parcelRegister("2vVvv", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $57725dc45b51a081$var$attachmentSizeErrorFlagI18n = (0, $aXWIB.defineMessages)({
    errorTitle: {
        id: "fabric-media-support.attachment-size-limit-error.title",
        defaultMessage: "{fileName} is too large to upload"
    },
    errorDescription: {
        id: "fabric-media-support.attachment-size-limit-error.description",
        defaultMessage: "Attachments must be {size} or less."
    },
    learnMore: {
        id: "fabric-media-support.attachment-size-limit-error.learn-more",
        defaultMessage: "Learn more"
    }
});
const $57725dc45b51a081$var$sizeLimitLearnMoreLink = 'https://support.atlassian.com/confluence-cloud/docs/upload-a-file/';
const $57725dc45b51a081$var$attachmentZeroByteErrorFlagI18n = (0, $aXWIB.defineMessages)({
    errorTitle: {
        id: "fabric-media-support.attachment-zero-byte-error.title",
        defaultMessage: "{fileName} is empty (zero bytes)"
    },
    errorDescription: {
        id: "fabric-media-support.attachment-zero-byte.description",
        defaultMessage: "Attachments must be at least 1 byte of size"
    }
});
const $57725dc45b51a081$export$f2d538a5633fea72 = (bytes, maxMagnitude)=>{
    if (bytes <= 0) return '0 bytes';
    const k = 1024;
    const decimals = 2;
    const units = [
        'bytes',
        'KB',
        'MB',
        'GB',
        'TB',
        'PB',
        'EB',
        'ZB',
        'YB'
    ];
    let maxIndex = units.length - 1;
    let exponent = Math.floor(Math.log(bytes) / Math.log(k));
    if (maxMagnitude && maxMagnitude < maxIndex) maxIndex = maxMagnitude;
    exponent = exponent > maxIndex ? maxIndex : exponent;
    return `${parseFloat((bytes / Math.pow(k, exponent)).toFixed(decimals))} ${units[exponent]}`;
};
const $57725dc45b51a081$export$1c61cf0ed486df46 = (data, intl)=>{
    if (data.reason === 'fileSizeLimitExceeded') return {
        title: intl.formatMessage($57725dc45b51a081$var$attachmentSizeErrorFlagI18n.errorTitle, {
            fileName: data.fileName
        }),
        description: intl.formatMessage($57725dc45b51a081$var$attachmentSizeErrorFlagI18n.errorDescription, {
            size: $57725dc45b51a081$export$f2d538a5633fea72(data.limit)
        }),
        actions: [
            {
                content: intl.formatMessage($57725dc45b51a081$var$attachmentSizeErrorFlagI18n.learnMore),
                onClick: ()=>{
                    window.open($57725dc45b51a081$var$sizeLimitLearnMoreLink, '_blank');
                }
            }
        ]
    };
    else return {
        title: intl.formatMessage($57725dc45b51a081$var$attachmentZeroByteErrorFlagI18n.errorTitle, {
            fileName: data.fileName
        }),
        description: intl.formatMessage($57725dc45b51a081$var$attachmentZeroByteErrorFlagI18n.errorDescription)
    };
};
module.exports["getAttachmentSizeLimitErrorFlag"] = $57725dc45b51a081$export$1c61cf0ed486df46;

});

parcelRegister("gXrHX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $k3pHv = parcelRequire("k3pHv");

const $a357cfbdfa4d3d24$export$74d34469a946b330 = /*#__PURE__*/ (0, $42omo.createContext)({
    isExternalShareRequest: false,
    userType: (0, $k3pHv.UserTypes).ANONYMOUS,
    shareToken: undefined,
    isAccessLinkRequest: false
});
module.exports["ExternalShareContext"] = $a357cfbdfa4d3d24$export$74d34469a946b330;

});

parcelRegister("k3pHv", function(module, exports) {
var $dcb154d9b517823f$export$df06b7fc047181f5 = /*#__PURE__*/ function(UserTypes) {
    // Anonymous users, not logged in
    UserTypes["ANONYMOUS"] = "anonymous";
    // Logged in, not Confluence user - member in the org
    UserTypes["ORG_MEMBER"] = "org-member";
    // Logged in, Licensed Confluence user
    UserTypes["CONFLUENCE_USER"] = "confluence-user";
    // Logged in, Atlassian user not in the org
    UserTypes["ATLASSIAN_USER"] = "atlassian-user";
    return UserTypes;
}({});
module.exports["UserTypes"] = $dcb154d9b517823f$export$df06b7fc047181f5;

});

parcelRegister("aJv6Q", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4PPzL = parcelRequire("4PPzL");


var $hSqtY = parcelRequire("hSqtY");

function $1d5814e83a6e1177$export$f0c7a449e0cfaec7(errorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $4PPzL.ErrorBoundary), errorBoundaryProps);
}
function $1d5814e83a6e1177$export$c5425be6daeb353e(transparentErrorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $hSqtY.TransparentErrorBoundary), transparentErrorBoundaryProps);
}
function $1d5814e83a6e1177$export$e54e24a14e23c644(BoundaryComponent, boundaryProps) {
    return function(WrappedComponent) {
        return (wrappedProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(BoundaryComponent, boundaryProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, wrappedProps));
    };
}
module.exports["withErrorBoundary"] = $1d5814e83a6e1177$export$f0c7a449e0cfaec7;
module.exports["withTypedErrorBoundary"] = $1d5814e83a6e1177$export$e54e24a14e23c644;
module.exports["withTransparentErrorBoundary"] = $1d5814e83a6e1177$export$c5425be6daeb353e;

});

parcelRegister("dA1Sn", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");

const $18ccf8477934fc9e$export$2a8604960d7d23d9 = 30000;
const $18ccf8477934fc9e$var$useTwoStageHydration = (name, enabled)=>{
    const fullCycleOutput = window.__FULLCYCLE__?.[name];
    const isNoSSR = !window.__SSR_RENDERED__;
    // Rely on a normal hydration/rendering flow when it's a transition or there's no full cycle output
    // or when experience is not hydratable
    const [hydrated, setHydrated] = (0, $42omo.useState)(isNoSSR || !fullCycleOutput || !window.__HYDRATABLE__ || !enabled);
    (0, $42omo.useEffect)(()=>{
        setHydrated(true);
        const cleanup = ()=>{
            delete window.__FULLCYCLE__?.[name];
        };
        // Arbitrary 30s CLEANUP_TIMEOUT to allow for the element to be rendered before removal
        // to not force an unecessary re-render or flash of blank content, even in slowest cases
        setTimeout(cleanup, $18ccf8477934fc9e$export$2a8604960d7d23d9);
        return cleanup;
    }, [
        name
    ]);
    return {
        hydrated: hydrated,
        fullCycleOutput: fullCycleOutput
    };
};
const $18ccf8477934fc9e$export$ca5d80b93e3e21b2 = ()=>{
    const nodesForPartialHydration = document.querySelectorAll('[data-fullcycle-name]');
    if (nodesForPartialHydration.length > 0) window.__FULLCYCLE__ = Array.from(nodesForPartialHydration).reduce((acc, node)=>{
        acc[node.dataset.fullcycleName] = node.innerHTML;
        return acc;
    }, {});
};
const $18ccf8477934fc9e$export$137b13ff1789fa49 = (t0)=>{
    const $ = (0, $frIzR.c)(28);
    const { style: style, name: name, children: children, enabled: t1, ssrPlaceholder: t2 } = t0;
    const enabled = t1 === undefined ? false : t1;
    const ssrPlaceholder = t2 === undefined ? false : t2;
    const { hydrated: hydrated, fullCycleOutput: fullCycleOutput } = $18ccf8477934fc9e$var$useTwoStageHydration(name, enabled);
    if ((0, $6mKj3.expValEquals)("cc_fix_hydration_ttvc", "isEnabled", true)) {
        if (!enabled) return children;
        if (hydrated) {
            let t3;
            if ($[0] !== name || $[1] !== ssrPlaceholder) {
                t3 = ssrPlaceholder ? {
                    "data-ssr-placeholder": name,
                    "data-ssr-placeholder-replace": name
                } : {};
                $[0] = name;
                $[1] = ssrPlaceholder;
                $[2] = t3;
            } else t3 = $[2];
            let t4;
            if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
                t4 = {
                    position: "relative",
                    height: "100%",
                    width: "100%"
                };
                $[3] = t4;
            } else t4 = $[3];
            let t5;
            if ($[4] !== children || $[5] !== name || $[6] !== t3) {
                t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                    "data-testid": "two-stage-hydration",
                    "data-fullcycle-name": name,
                    ...t3,
                    style: t4
                }, children);
                $[4] = children;
                $[5] = name;
                $[6] = t3;
                $[7] = t5;
            } else t5 = $[7];
            return t5;
        }
        const innerHTML = fullCycleOutput;
        let t3;
        if ($[8] !== name || $[9] !== ssrPlaceholder) {
            t3 = ssrPlaceholder ? {
                "data-ssr-placeholder": name,
                "data-ssr-placeholder-replace": name
            } : {};
            $[8] = name;
            $[9] = ssrPlaceholder;
            $[10] = t3;
        } else t3 = $[10];
        let t4;
        if ($[11] !== innerHTML) {
            t4 = {
                __html: innerHTML
            };
            $[11] = innerHTML;
            $[12] = t4;
        } else t4 = $[12];
        let t5;
        if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
            t5 = {
                position: "relative",
                height: "100%",
                width: "100%"
            };
            $[13] = t5;
        } else t5 = $[13];
        let t6;
        if ($[14] !== name || $[15] !== t3 || $[16] !== t4) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                "data-testid": "two-stage-hydration",
                "data-fullcycle-name": name,
                ...t3,
                dangerouslySetInnerHTML: t4,
                style: t5
            });
            $[14] = name;
            $[15] = t3;
            $[16] = t4;
            $[17] = t6;
        } else t6 = $[17];
        return t6;
    }
    if (!enabled || hydrated) return children;
    const innerHTML_0 = fullCycleOutput;
    let t3;
    if ($[22] !== innerHTML_0) {
        t3 = {
            __html: innerHTML_0
        };
        $[22] = innerHTML_0;
        $[23] = t3;
    } else t3 = $[23];
    let t4;
    if ($[24] !== name || $[25] !== style || $[26] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: style,
            "data-testid": "two-stage-hydration",
            "data-fullcycle-name": name,
            dangerouslySetInnerHTML: t3
        });
        $[24] = name;
        $[25] = style;
        $[26] = t3;
        $[27] = t4;
    } else t4 = $[27];
    return t4;
};
const $18ccf8477934fc9e$export$b6db8e1e111c3550 = (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { name: name, style: style, children: children, enabled: t1, ssrPlaceholder: t2 } = t0;
    const enabled = t1 === undefined ? true : t1;
    const ssrPlaceholder = t2 === undefined ? false : t2;
    let t3;
    if ($[0] !== children || $[1] !== enabled || $[2] !== name || $[3] !== ssrPlaceholder || $[4] !== style) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($18ccf8477934fc9e$export$137b13ff1789fa49, {
            name: name,
            style: style,
            enabled: enabled,
            ssrPlaceholder: ssrPlaceholder
        }, children);
        $[0] = children;
        $[1] = enabled;
        $[2] = name;
        $[3] = ssrPlaceholder;
        $[4] = style;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
};
module.exports["saveFullCycleOutput"] = $18ccf8477934fc9e$export$ca5d80b93e3e21b2;
module.exports["TwoStageHydration"] = $18ccf8477934fc9e$export$b6db8e1e111c3550;

});

parcelRegister("lC6Qd", function(module, exports) {
/**
 * @generated SignedSource<<222524e9edc9d9e64505b61c38fde3e9>>
 * @relayHash eca6e9d325c97f4fd5880178ecc63561
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e2e9338430096a14321d43ffc4d7c87126164ce6f2d44ea4ede01d437b0ec12d
const $03de5ecc01e321ee$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "cover-picture-id-draft",
                                        "cover-picture-id-published"
                                    ]
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        },
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "number"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"])"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CoverPictureQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CoverPictureQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "eca6e9d325c97f4fd5880178ecc63561",
            "id": "e2e9338430096a14321d43ffc4d7c87126164ce6f2d44ea4ede01d437b0ec12d",
            "metadata": {},
            "name": "CoverPictureQuery",
            "operationKind": "query",
            "text": "query CoverPictureQuery($contentId:ID,$status:[String],$draftShareId:String){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"]){nodes{id,key,value,version{number}}}}}}"
        }
    };
}();
$03de5ecc01e321ee$var$node.hash = "cbe85309884dfe8220661d705f977e0f";
var $03de5ecc01e321ee$export$2e2bcd8739ae039 = $03de5ecc01e321ee$var$node;
module.exports["default"] = $03de5ecc01e321ee$export$2e2bcd8739ae039;

});

parcelRegister("jOIil", function(module, exports) {
class $3057f4cb0fd3db76$var$EventHub {
    /**
   * Subscribes to a specific Editor AI event, registering a callback function that will be invoked whenever the event is published.
   *
   * @param {object} params - The subscription parameters.
   * @param {T} params.event - The name of the event to subscribe to.
   * @param {(data: EventDataMap[T]) => void} params.callback - The callback function to invoke when the event is published.
   * It receives the event data as its parameter.
   * @returns {object} An object containing the `unsubscribe` method to remove the subscription when it's no longer needed.
   *
   * @example
   * // Subscribing to an event
   * const subscription = eventHub.subscribe({
   *   event: 'start prompt',
   *   callback: (data) => {
   *     console.log('Received start prompt event:', data);
   *   },
   * });
   *
   * // Later, to unsubscribe
   * subscription.unsubscribe();
   */ subscribe({ event: event, callback: callback }) {
        const callbacks = this.subscribers.get(event) || [];
        this.subscribers.set(event, [
            ...callbacks,
            callback
        ]);
        return {
            unsubscribe: ()=>{
                const callbacks = this.subscribers.get(event)?.filter((sub)=>sub !== callback) || [];
                if (callbacks.length > 0) this.subscribers.set(event, callbacks);
                else this.subscribers.delete(event);
            }
        };
    }
    /**
   * Publishes an Editor AI event to a target editor. (This will usually be an event like 'start prompt').
   *
   * @param {object} params - The event parameters.
   * @param {T} params.event - The name of the event to publish.
   * @param {ToEditorEventDataMap[T]} params.data - The data associated with the event, specific to the event type.
   * @returns {void}
   *
   * @example
   * // Publishing an event to the editor
   * eventHub.publishToEditor({
   *   event: 'start prompt',
   *   data: {
   *     prompt: 'issue reformatter',
   *     targetEditorId,
   *     analyticSourceId: 'jiraIssueReformatterExternalButton',
   *   },
   * });
   */ publishToEditor({ event: event, data: data }) {
        const callbacks = this.subscribers.get(event) || [];
        callbacks.forEach((callback)=>{
            callback(data);
        });
    }
    /**
   * Publishes an event originating from the editor, invoking all registered subscribers for that event.
   *
   * @param {object} params - The event parameters.
   * @param {T} params.event - The name of the event to publish.
   * @param {FromEditorEventDataMap[T]} params.data - The data associated with the event, specific to the event type.
   * @returns {void}
   *
   * @example
   * // Publishing an event from the editor
   * eventHub.publishFromEditor({
   *   event: 'replace title in confluence',
   *   data: {
   *     analyticSourceId: 'confluenceTitleToolbar',
   *     sourceEditorId,
   *     title: textContent,
   *   },
   * });
   */ publishFromEditor({ event: event, data: data }) {
        const callbacks = this.subscribers.get(event) || [];
        callbacks.forEach((callback)=>{
            callback(data);
        });
    }
    constructor(){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.subscribers = new Map();
        this.subscribers = new Map();
    }
}
const $3057f4cb0fd3db76$export$e17a52e5da72c4cb = new $3057f4cb0fd3db76$var$EventHub();
module.exports["eventHub"] = $3057f4cb0fd3db76$export$e17a52e5da72c4cb;

});

parcelRegister("19w2x", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6ttbq = parcelRequire("6ttbq");


var $83H3T = parcelRequire("83H3T");


var $dclyF = parcelRequire("dclyF");


var $hUAWL = parcelRequire("hUAWL");


var $2K5gO = parcelRequire("2K5gO");


var $4QtAs = parcelRequire("4QtAs");

/**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $105205360274b3e9$var$parseCSSTimeToMs(value) {
    const parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function $105205360274b3e9$var$hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function $105205360274b3e9$var$getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
const $105205360274b3e9$export$a300664a1a230956 = ({ dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion })=>{
    const prevDimensions = (0, $42omo.useRef)();
    const [element, setElementRef] = (0, $83H3T.useElementRef)();
    const setTimeout = (0, $2K5gO.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $hUAWL.useRequestAnimationFrame)();
    (0, $4QtAs.useSnapshotBeforeUpdate)(()=>{
        if ((0, $6ttbq.isReducedMotion)() || !element) return;
        const rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, $dclyF.useLayoutEffect)(()=>{
        if ((0, $6ttbq.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        const rect = element.getBoundingClientRect();
        const nextDimensions = {
            width: rect.width,
            height: rect.height
        };
        if (!$105205360274b3e9$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion?.();
            return;
        }
        const propertyList = $105205360274b3e9$var$getDimensionPropertyList(dimension);
        const newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = `${prevDimensions.current.width}px`;
        if (dimension === 'height' || dimension === 'both') newStyles.height = `${prevDimensions.current.height}px`;
        Object.assign(element.style, newStyles);
        const resolvedDuration = $105205360274b3e9$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = `${nextDimensions.width}px`;
                if (dimension === 'height' || dimension === 'both') element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion?.();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
module.exports["useResizing"] = $105205360274b3e9$export$a300664a1a230956;

});

parcelRegister("83H3T", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $68de0fcb6733268f$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $42omo.useRef)(null);
    const setRef = (0, $42omo.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};
module.exports["useElementRef"] = $68de0fcb6733268f$export$ff879f35a69d56b7;

});

parcelRegister("hUAWL", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $9fe18f2334f78b72$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $9fe18f2334f78b72$export$1775f27e7c8051ca = (opts = {
    cleanup: 'unmount'
})=>{
    const frames = (0, $42omo.useRef)([]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (frames.current.length) {
                frames.current.forEach((id)=>cancelAnimationFrame(id));
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $9fe18f2334f78b72$var$getHookDeps(opts));
    return (0, $42omo.useCallback)((handler)=>{
        const id = requestAnimationFrame((time)=>{
            frames.current = frames.current.filter((frameId)=>frameId !== id);
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
module.exports["useRequestAnimationFrame"] = $9fe18f2334f78b72$export$1775f27e7c8051ca;

});

parcelRegister("4QtAs", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dclyF = parcelRequire("dclyF");

const $0136602141ebd577$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $42omo.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $dclyF.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};
module.exports["useSnapshotBeforeUpdate"] = $0136602141ebd577$export$9e95200239cd148b;

});

parcelRegister("eWRwJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca4f3d8c1426d3d8$export$2e2bcd8739ae039);
var $ca4f3d8c1426d3d8$export$2e2bcd8739ae039 = (channel)=>(payload)=>(createAnalyticsEvent)=>{
            const consumerEvent = createAnalyticsEvent(payload);
            const clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };

});

parcelRegister("38Ncj", function(module, exports) {
/**
 * @generated SignedSource<<184e3b4a6a4d0eaacdf3541ca3bb9b58>>
 * @relayHash 21cebd3db50676fd19d57554f2f4d6fc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fcc453c87e447898e23b0fd063f4631ca349fe93580bd0dea45de46209594904
const $630a58f9ca4672ab$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isContentTypePublicLinkEligible"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasInheritedRestrictions"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasRestrictions"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasViewRestrictions"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ]
        },
        {
            "condition": "isContentTypePublicLinkEligible",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "contentId"
                        }
                    ],
                    "concreteType": "PublicLinkPage",
                    "kind": "LinkedField",
                    "name": "publicLinkPage",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "pageId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "pageStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "accessType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useShareAndRestrictButtonDataQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useShareAndRestrictButtonDataQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "21cebd3db50676fd19d57554f2f4d6fc",
            "id": "fcc453c87e447898e23b0fd063f4631ca349fe93580bd0dea45de46209594904",
            "metadata": {},
            "name": "useShareAndRestrictButtonDataQuery",
            "operationKind": "query",
            "text": "query useShareAndRestrictButtonDataQuery($contentId:ID!,$isContentTypePublicLinkEligible:Boolean!){singleContent(id:$contentId){id,hasInheritedRestrictions,hasRestrictions,hasViewRestrictions,title},publicLinkPage(pageId:$contentId)@include(if:$isContentTypePublicLinkEligible){pageId,pageStatus,accessType}}"
        }
    };
}();
$630a58f9ca4672ab$var$node.hash = "336fe7f51ff27baeb231379611028a5d";
var $630a58f9ca4672ab$export$2e2bcd8739ae039 = $630a58f9ca4672ab$var$node;
module.exports["default"] = $630a58f9ca4672ab$export$2e2bcd8739ae039;

});

parcelRegister("jeQ9x", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $3Ttlf = parcelRequire("3Ttlf");


const $476a1a146c5d6cec$export$c41c4f98f15bcd25 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "I7qQB",
    name: "PublishButtonWithMoreOptions",
    loader: async ()=>{
        return (await (parcelRequire("e2vwV"))).PublishButtonWithMoreOptions;
    },
    loading: (0, $3Ttlf.PlaceholderPublishButton)
});
module.exports["PublishButtonWithMoreOptions"] = $476a1a146c5d6cec$export$c41c4f98f15bcd25;

});

parcelRegister("3Ttlf", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ghftu = parcelRequire("ghftu");


var $ccHMk = parcelRequire("ccHMk");

var $1qfLF = parcelRequire("1qfLF");

var $9gE7g = parcelRequire("9gE7g");


var $buthI = parcelRequire("buthI");


var $9wGTI = parcelRequire("9wGTI");


var $lACKt = parcelRequire("lACKt");

const $6d1be32de0860931$export$a6f3e6c7a6e250cc = ({ publishButtonDisabled: publishButtonDisabled, isUnpublishedDraft: isUnpublishedDraft, shouldShowWorldIcon: shouldShowWorldIcon })=>{
    const intl = (0, $aXWIB.useIntl)();
    if (!isUnpublishedDraft) {
        const WorldIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($buthI))), {
                label: intl.formatMessage((0, $lACKt.i18nShared).updatePublicContentLabel),
                color: "var(--ds-icon-inverse, #FFFFFF)"
            });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9gE7g.SplitButton), {
            appearance: "primary",
            isDisabled: publishButtonDisabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "primary",
            isDisabled: publishButtonDisabled,
            iconBefore: shouldShowWorldIcon ? WorldIcon : undefined
        }, intl.formatMessage((0, $lACKt.i18nShared).updateButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                    ...iconProps,
                    size: "small"
                }),
            label: intl.formatMessage((0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? (0, $lACKt.i18nShared).chevronButtonTooltipObjectHeader : (0, $lACKt.i18nShared).chevronButtonTooltip)
        }));
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        isDisabled: publishButtonDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $lACKt.i18nShared).publishButton));
};
module.exports["PlaceholderPublishButton"] = $6d1be32de0860931$export$a6f3e6c7a6e250cc;

});

parcelRegister("lACKt", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $f823ee887c9ee745$export$54342bba4612eedb = (0, $aXWIB.defineMessages)({
    publishButton: {
        id: "publish-modal.default-publish-button",
        defaultMessage: "Publish..."
    },
    updateButton: {
        id: "publish-modal.update-button",
        defaultMessage: "Update"
    },
    chevronButtonTooltip: {
        id: "publish-modal.split-button-tooltip",
        defaultMessage: "Adjust update settings"
    },
    chevronButtonTooltipObjectHeader: {
        id: "publish-modal.split-button-tooltip.object-header",
        defaultMessage: "Update settings"
    },
    updatePublicContentLabel: {
        id: "publish-modal.update-public-content-label",
        defaultMessage: "Update public content"
    }
});
module.exports["i18nShared"] = $f823ee887c9ee745$export$54342bba4612eedb;

});

parcelRegister("e2vwV", function(module, exports) {

let $a389b5d13ba067b6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a389b5d13ba067b6$var$load("kFiBp"),
    $a389b5d13ba067b6$var$load("6wr18"),
    $a389b5d13ba067b6$var$load("6HLQW"),
    $a389b5d13ba067b6$var$load("kahM9"),
    $a389b5d13ba067b6$var$load("2jnsQ"),
    $a389b5d13ba067b6$var$load("j8Ant"),
    $a389b5d13ba067b6$var$load("5zDuS"),
    $a389b5d13ba067b6$var$load("4KvE8"),
    $a389b5d13ba067b6$var$load("2F69B"),
    $a389b5d13ba067b6$var$load("7EorR"),
    $a389b5d13ba067b6$var$load("k3Ays"),
    $a389b5d13ba067b6$var$load("hhss7"),
    $a389b5d13ba067b6$var$load("ffEVr"),
    $a389b5d13ba067b6$var$load("jbM5v"),
    $a389b5d13ba067b6$var$load("89b92")
]).then(()=>parcelRequire('6cfXd'));

});

parcelRegister("cxCWb", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $gaGKC = parcelRequire("gaGKC");


const $56c3dbef55a81b41$export$a1f5ff36b0810fd8 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "0sh4s",
    name: "FavouriteButton",
    loader: async ()=>(await (parcelRequire("bgwJV"))).FavouriteButton,
    loading: (0, $gaGKC.FavouriteButtonPlaceholder)
});

const $56c3dbef55a81b41$export$4151d732511e5aa6 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "m_S4n",
    name: "LazyFavouriteButton",
    loader: async ()=>(await (parcelRequire("bgwJV"))).FavouriteButton,
    loading: (0, $gaGKC.FavouriteButtonPlaceholder)
});
module.exports["FavouriteButton"] = $56c3dbef55a81b41$export$a1f5ff36b0810fd8;
module.exports["LazyFavouriteButton"] = $56c3dbef55a81b41$export$4151d732511e5aa6;

});

parcelRegister("gaGKC", function(module, exports) {
/* FavouriteButtonPlaceholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $eEA8O = parcelRequire("eEA8O");


var $kfYj7 = parcelRequire("kfYj7");

const $97ecf1ddef823285$var$i18n = (0, $aXWIB.defineMessages)({
    starLabel: {
        id: "favourite-button.placeholder.star.label",
        defaultMessage: "Star"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97ecf1ddef823285$var$StyledButton = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $eEA8O.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_701w1ul9 _1yxxv77o _w8sqv77o",
            __cmplp.className
        ])
    });
});
const $97ecf1ddef823285$export$d599e45cb4e3913 = ()=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($97ecf1ddef823285$var$StyledButton, {
        "data-test-id": "page-favourite-button-placeholder",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kfYj7))), {
            label: formatMessage($97ecf1ddef823285$var$i18n.starLabel),
            color: "currentColor",
            spacing: "spacious"
        }),
        isDisabled: true
    });
};
module.exports["FavouriteButtonPlaceholder"] = $97ecf1ddef823285$export$d599e45cb4e3913;

});

parcelRegister("bgwJV", function(module, exports) {

let $833a95bcc4f01c2c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $833a95bcc4f01c2c$var$load("4KvE8"),
    $833a95bcc4f01c2c$var$load("gOkMN"),
    $833a95bcc4f01c2c$var$load("6wr18"),
    $833a95bcc4f01c2c$var$load("ffEVr"),
    $833a95bcc4f01c2c$var$load("e1RjR"),
    $833a95bcc4f01c2c$var$load("1sXQt")
]).then(()=>parcelRequire('lDaLP'));

});

parcelRegister("aBfpe", function(module, exports) {
/**
 * https://www.iana.org/assignments/media-types/media-types.xhtml
 */ var $c27c52d002752847$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $c27c52d002752847$export$483c11740a902fcd;

});

parcelRegister("dpPtd", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aD1SW = parcelRequire("aD1SW");


var $eCEXz = parcelRequire("eCEXz");


var $6uGcC = parcelRequire("6uGcC");

const $c997cd3fd9f4ee84$var$FlagContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(null);
function $c997cd3fd9f4ee84$export$2879604e6aec4ab() {
    const api = (0, $42omo.useContext)($c997cd3fd9f4ee84$var$FlagContext);
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
}
const $c997cd3fd9f4ee84$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
function $c997cd3fd9f4ee84$export$a4270ab432ac8a58({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $42omo.useState)([]);
    const removeFlag = (0, $42omo.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $42omo.useMemo)(()=>({
            showFlag: function show(value) {
                const flag = {
                    ...value,
                    id: value.id || $c997cd3fd9f4ee84$var$getUniqueId()
                };
                setFlags((current)=>{
                    const index = current.findIndex((value)=>value.id === flag.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag,
                        ...current
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current
                    ];
                    shallow[index] = flag;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag.id);
                };
            },
            hideFlag: removeFlag
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c997cd3fd9f4ee84$var$FlagContext.Provider, {
        value: api
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6uGcC.default), {
        onDismissed: removeFlag,
        shouldRenderToParent: shouldRenderToParent
    }, flags.map((flag)=>{
        const { isAutoDismiss: isAutoDismiss, ...restProps } = flag;
        const FlagType = isAutoDismiss ? (0, $aD1SW.default) : (0, $eCEXz.default);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(FlagType, {
            ...restProps,
            key: flag.id
        });
    })));
}
const $c997cd3fd9f4ee84$export$7b676815c264eaf3 = (fn)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c997cd3fd9f4ee84$export$a4270ab432ac8a58, null, fn());
module.exports["useFlags"] = $c997cd3fd9f4ee84$export$2879604e6aec4ab;
module.exports["FlagsProvider"] = $c997cd3fd9f4ee84$export$a4270ab432ac8a58;

});

parcelRegister("3hoG4", function(module, exports) {
$parcel$export(module.exports, "default", () => $b38c95e6dd3d3e2d$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $b38c95e6dd3d3e2d$export$2e2bcd8739ae039 = (0, $42omo.forwardRef);

});

parcelRegister("9EtP6", function(module, exports) {
/* text-area.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $42omo = parcelRequire("42omo");


var $gxtzC = parcelRequire("gxtzC");


var $dh538 = parcelRequire("dh538");

const $82c18ff824db72a8$var$packageName = "platform-pkg";
const $82c18ff824db72a8$var$packageVersion = "0.0.0-use.local";
const $82c18ff824db72a8$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $82c18ff824db72a8$var$packageName,
    packageVersion: $82c18ff824db72a8$var$packageVersion
};
const $82c18ff824db72a8$var$lineHeightBase = 20;
const $82c18ff824db72a8$var$lineHeightCompact = 16;
const $82c18ff824db72a8$var$compactVerticalPadding = 2;
const $82c18ff824db72a8$var$verticalPadding = 6;
const $82c18ff824db72a8$var$transitionDuration = '0.2s';
const $82c18ff824db72a8$var$borderWidth = 2;
const $82c18ff824db72a8$var$baseStyles = null;
const $82c18ff824db72a8$var$baseStylesT26Shape = null;
const $82c18ff824db72a8$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp82rsbi _1ltx1j9a _1bqsbk0g _z1pv187o _19wtrsbi _12yml4ek _1l02v77o _11zpv77o _141f1v6z _daj71v6z _olc612x7 _14ji12x7 _7ba01v6z _1kod1v6z _858u1v1w _jomrr01l _7ehivyy1 _186j1v1w _qu18187o",
    subtle: "_1dqonqa1 _kp821j28 _1ltx1j28 _19wtrsbi _12yml4ek _1l02v77o _11zpv77o _141f1v6z _daj71v6z _olc612x7 _14ji12x7 _1kod1v6z _7ba01v6z _858u1v1w _jomrr01l _7ehivyy1",
    none: "_1dqoglyw _kp821j28 _1ltx1j28 _19wt1j28 _12ym1j28 _1l02v77o _daj712x7 _11zpv77o _141f12x7 _olc612x7 _1kod12x7 _14ji12x7 _7ba012x7 _858u1j28 _jomr1j28 _7ehi3sij"
}; // iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on mobile devices, the textarea uses font.body.large (16px) by default,
// then switches to the smaller font.body on screens wider than 30rem (desktop).
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e
const $82c18ff824db72a8$var$fontStyles = {
    default: "_11c81d4k _1tn2fhey",
    monospace: "_11c81d4k _ect4zzfg _1tn2fhey _14md1vhz"
};
const $82c18ff824db72a8$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
const $82c18ff824db72a8$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $82c18ff824db72a8$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $82c18ff824db72a8$var$InnerTextArea = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const ourRef = (0, $42omo.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const borderHeight = (0, $42omo.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $42omo.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $82c18ff824db72a8$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$82c18ff824db72a8$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$82c18ff824db72a8$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $42omo.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $82c18ff824db72a8$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rkofajl _11c8fhey _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazi7uo _slp31hna _153g1bqt _usy41j9a _1a2sizbr _vbqb1gmx _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra1bqt _ibjdl4ek _6zpvizbr _19k0187o _1idr1rpy _1lep1gmx _nmhq1fiz _1n388sxn _1luh1v1w _ndzbr01l _1vj0vyy1",
            (0, $dh538.fg)('platform-dst-shape-theme-default') && "_2rko1qi0",
            $82c18ff824db72a8$var$appearanceStyles[appearance],
            $82c18ff824db72a8$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $82c18ff824db72a8$var$resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $7sObp.default)($82c18ff824db72a8$var$lineHeightCompact * minimumRows + $82c18ff824db72a8$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $7sObp.default)($82c18ff824db72a8$var$lineHeightBase * minimumRows + $82c18ff824db72a8$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
}); /**
     * __Text area__
     *
     * A text area lets users enter long form text which spans over multiple lines.
     *
     * - [Examples](https://atlassian.design/components/textarea/examples)
     * - [Code](https://atlassian.design/components/textarea/code)
     * - [Usage](https://atlassian.design/components/textarea/usage)
     */ 
const $82c18ff824db72a8$var$TextArea = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($82c18ff824db72a8$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$82c18ff824db72a8$var$TextArea.displayName = 'TextArea';
var $82c18ff824db72a8$export$2e2bcd8739ae039 = $82c18ff824db72a8$var$TextArea;
module.exports["default"] = $82c18ff824db72a8$export$2e2bcd8739ae039;

});

parcelRegister("9ILXP", function(module, exports) {
function $713d6dc98197981e$var$e(e) {
    this.message = e;
}
$713d6dc98197981e$var$e.prototype = new Error, $713d6dc98197981e$var$e.prototype.name = "InvalidCharacterError";
var $713d6dc98197981e$var$r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $713d6dc98197981e$var$e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) && (c += String.fromCharCode(255 & n >> (-2 * a & 6))))o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
    return c;
};
function $713d6dc98197981e$var$t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent($713d6dc98197981e$var$r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return $713d6dc98197981e$var$r(t);
    }
}
function $713d6dc98197981e$export$b9721ef022f71a68(e) {
    this.message = e;
}
function $713d6dc98197981e$var$o(e, r) {
    if ("string" != typeof e) throw new $713d6dc98197981e$export$b9721ef022f71a68("Invalid token specified");
    var o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse($713d6dc98197981e$var$t(e.split(".")[o]));
    } catch (e) {
        throw new $713d6dc98197981e$export$b9721ef022f71a68("Invalid token specified: " + e.message);
    }
}
$713d6dc98197981e$export$b9721ef022f71a68.prototype = new Error, $713d6dc98197981e$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
var $713d6dc98197981e$export$2e2bcd8739ae039 = $713d6dc98197981e$var$o;
module.exports["default"] = $713d6dc98197981e$export$2e2bcd8739ae039;

});

parcelRegister("4GGNn", function(module, exports) {

var $jhbO3 = parcelRequire("jhbO3");


var $GLgaM = parcelRequire("GLgaM");


var $bjeS8 = parcelRequire("bjeS8");

async function $aeaa62655b9da260$export$4199ef03ec2aea3f({ url: url, method: method, headers: headers, body: body, credentials: credentials, variables: variables, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError }) {
    const fetchData = async ()=>{
        const json = await (0, $GLgaM.fetchResponse)({
            url: url,
            method: method,
            body: body,
            headers: headers,
            credentials: credentials,
            parseResponseOnSuccess: parseResponseOnSuccess,
            parseResponseOnError: parseResponseOnError
        }, variables);
        return await parseResult(json, variables);
    };
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $jhbO3.apolloCompatibleMutation)({
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["experimentalMutate"] = $aeaa62655b9da260$export$4199ef03ec2aea3f;

});

parcelRegister("9k33u", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $grxv4 = parcelRequire("grxv4");


var $8IHds = parcelRequire("8IHds");

const $93e9546cb0a1512c$export$c94ff18a59d4c4d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(undefined);
const $93e9546cb0a1512c$export$57164260bc1f1218 = ({ children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings })=>{
    const mediaClient = (0, $42omo.useMemo)(()=>(0, $grxv4.getMediaClient)(mediaClientConfig), [
        mediaClientConfig
    ]);
    const settings = (0, $8IHds.useMediaParsedSettings)(mediaSettings);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($93e9546cb0a1512c$export$c94ff18a59d4c4d.Provider, {
        value: {
            mediaClient: mediaClient,
            settings: settings
        }
    }, children);
};
module.exports["MediaContext"] = $93e9546cb0a1512c$export$c94ff18a59d4c4d;
module.exports["MediaProvider"] = $93e9546cb0a1512c$export$57164260bc1f1218;

});

parcelRegister("8IHds", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $82Dle = parcelRequire("82Dle");

const $ad9bb6183b9f6f81$export$d54af28440a5efc0 = (mediaSettings = {})=>{
    const settings = (0, $42omo.useMemo)(()=>{
        const newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $82Dle.defaultMediaUserPreferences);
        return newSettings;
    }, [
        mediaSettings
    ]);
    return settings;
};
module.exports["useMediaParsedSettings"] = $ad9bb6183b9f6f81$export$d54af28440a5efc0;

});

parcelRegister("82Dle", function(module, exports) {
// Currently only supports boolean, string. Uncomment below to support number
const $3a61632aaf261ebb$var$MediaUserPreferencesTypes = {
    videoCaptionsEnabled: 'boolean',
    videoCaptionsPreferredLocale: 'string'
};
const $3a61632aaf261ebb$export$7e209e67b965bc63 = (userPreferences)=>({
        set: (key, value)=>{
            userPreferences.set(key, value.toString());
        },
        get: (key)=>{
            const value = userPreferences.get(key);
            if (value === null || value === undefined) return undefined;
            if ($3a61632aaf261ebb$var$MediaUserPreferencesTypes[key] === 'boolean') return value === 'true';
            // Uncomment to support number
            // if (MediaUserSettingsTypes[key] === 'number') {
            // 	return Number(value) as MediaSettingsTypeMap[K];
            // }
            return value;
        }
    });
const $3a61632aaf261ebb$var$defaultUserPreferences = {
    set: (key, value)=>{
        const MEDIA_KEY = 'media';
        localStorage.setItem(`${MEDIA_KEY}-${key}`, value);
    },
    get: (key)=>{
        const MEDIA_KEY = 'media';
        return localStorage.getItem(`${MEDIA_KEY}-${key}`);
    }
};
const $3a61632aaf261ebb$export$2d23ed2854ac1650 = $3a61632aaf261ebb$export$7e209e67b965bc63($3a61632aaf261ebb$var$defaultUserPreferences);
module.exports["defaultMediaUserPreferences"] = $3a61632aaf261ebb$export$2d23ed2854ac1650;

});

parcelRegister("jRNsq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3rvSa = parcelRequire("3rvSa");


var $9k33u = parcelRequire("9k33u");

const $9c13c2ba0d10a1f7$export$8b3e87ea56c3a345 = ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $3rvSa.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $9k33u.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error('No MediaClient set, use MediaClientProvider or MediaProvider to set one');
    // WARNING: typescript can't infer that at least one mediaClient is defined here. Adding the `!` is a hack to make typescript happy.
    return mediaClient || altMediaClient;
};
module.exports["useMediaClient"] = $9c13c2ba0d10a1f7$export$8b3e87ea56c3a345;

});

parcelRegister("i2CQL", function(module, exports) {

var $g99e4 = parcelRequire("g99e4");


var $jRNsq = parcelRequire("jRNsq");

const $4af3bbf76333cbc2$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $g99e4.useStore)(store, selector, equals);
function $4af3bbf76333cbc2$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $jRNsq.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $4af3bbf76333cbc2$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}
module.exports["useMediaStore"] = $4af3bbf76333cbc2$export$8a9cc8c330400af8;

});

parcelRegister("g99e4", function(module, exports) {
$parcel$export(module.exports, "useStore", () => $bc14a4aa688fca7b$export$6ccbb43953eebf8);

var $9mu1x = parcelRequire("9mu1x");


var $42omo = parcelRequire("42omo");


var $hpRUx = parcelRequire("hpRUx");

var $bc14a4aa688fca7b$import_meta = Object.assign(Object.create(null), {
    url: "file:///../platform/node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $bc14a4aa688fca7b$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo)));
const { useSyncExternalStoreWithSelector: $bc14a4aa688fca7b$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($hpRUx)));
let $bc14a4aa688fca7b$var$didWarnAboutEqualityFn = false;
const $bc14a4aa688fca7b$var$identity = (arg)=>arg;
function $bc14a4aa688fca7b$export$6ccbb43953eebf8(api, selector = $bc14a4aa688fca7b$var$identity, equalityFn) {
    if (($bc14a4aa688fca7b$import_meta.env ? $bc14a4aa688fca7b$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$bc14a4aa688fca7b$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $bc14a4aa688fca7b$var$didWarnAboutEqualityFn = true;
    }
    const slice = $bc14a4aa688fca7b$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $bc14a4aa688fca7b$var$useDebugValue(slice);
    return slice;
}
const $bc14a4aa688fca7b$var$createImpl = (createState)=>{
    if (($bc14a4aa688fca7b$import_meta.env ? $bc14a4aa688fca7b$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $9mu1x.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$bc14a4aa688fca7b$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $bc14a4aa688fca7b$export$185802fd694ee1f5 = (createState)=>createState ? $bc14a4aa688fca7b$var$createImpl(createState) : $bc14a4aa688fca7b$var$createImpl;
var $bc14a4aa688fca7b$export$2e2bcd8739ae039 = (createState)=>{
    if (($bc14a4aa688fca7b$import_meta.env ? $bc14a4aa688fca7b$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $bc14a4aa688fca7b$export$185802fd694ee1f5(createState);
};

});

parcelRegister("5yfLD", function(module, exports) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRegister("9URG7", function(module, exports) {
const $7498a8c5d7a74725$export$12cc65019788286c = {
    photorealistic: 'photorealistic',
    abstract: 'abstract',
    watercolors: 'watercolors',
    graphic_design: 'graphic_design',
    landscape: 'landscape'
};
module.exports["IMAGE_GENERATION_THEMES"] = $7498a8c5d7a74725$export$12cc65019788286c;

});


//# sourceMappingURL=EditorPageCoverPicture.44414c8b.js.map
